/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * Backend API
 * Backend API for Competition Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AdminAttachment,
  AdminAttachmentRequest,
  AdminCSVUserRequest,
  AdminCSVUserResult,
  AdminCompetitionRequest,
  AdminCompetitions,
  AdminCompettionsListParams,
  AdminDepartment,
  AdminDepartmentRequest,
  AdminDistributionCsvRequest,
  AdminDistributionCsvResult,
  AdminDistributionItem,
  AdminDistributionItemCreateRequest,
  AdminDistributionItemUpdateRequest,
  AdminDistributionItems,
  AdminDistributionPurge,
  AdminGrantedLicense,
  AdminLicense,
  AdminLicenseGrantSyncResponse,
  AdminLicenseParticipants,
  AdminLicenseRequest,
  AdminLicenseTeams,
  AdminLicenseTeamsRequest,
  AdminMachineEvaluationResultRequest,
  AdminMachineInferenceResultRequest,
  AdminOccupation,
  AdminOccupationRequest,
  AdminOrganization,
  AdminOrganizationRequest,
  AdminOrganizationUser,
  AdminSubmission,
  AdminUser,
  AdminUserRequestMultiOrganizations,
  AdminUsersListParams,
  BadRequest,
  CSVUpload,
  CompetitionDetail,
  Conflict,
  DistributionItemList,
  EvaluationMetrics,
  Forbidden,
  GetHealthCheckSuccess,
  HealthRequest,
  InternalServerError,
  LangflowSubmissionLimitResponse,
  LangflowSubmissionResponse,
  LangflowUpload,
  LicensedCompetitionDetail,
  ModelRagSubmissionResponse,
  ModelSubmissionResponse,
  NoContentResponse,
  NotFound,
  Organization,
  OrganizationDetail,
  OrganizationRequest,
  OrganizationUser,
  PatchedAdminAttachmentPatchRequest,
  PatchedAdminAttachmentRequest,
  PatchedAdminCompetitionRequest,
  PatchedAdminDepartmentRequest,
  PatchedAdminLicenseParticipantsKindRequest,
  PatchedAdminLicenseRequest,
  PatchedAdminOccupationRequest,
  PatchedAdminOrganizationRequest,
  PatchedOrganizationRequest,
  PatchedOrganizationUserPatchRequest,
  PatchedUserPatchRequest,
  PostHealthCheckSuccess,
  PostUserCheckSuccess,
  ResultSubmissionResponse,
  Unauthorized,
  UploadImage,
  User,
  UserCheckRequest,
  UserImageUpload,
  ZIPUpload
} from './backendAPI.schemas'
import { orvalAxiosAdapter } from '../orvalAxiosAdapter';



/**
 * 評価結果を受信するためのView.
evaluation_metrics_calculator_for_cloudrunからの評価結果を受信する

POST: 評価結果を受信
 */
export const adminMachineCompetitionsSubmissionsEvaluationResultsCreate = (
    competitionId: number,
    submissionId: string,
    adminMachineEvaluationResultRequest: AdminMachineEvaluationResultRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(adminMachineEvaluationResultRequest.score !== null) {
 formUrlEncoded.append('score', adminMachineEvaluationResultRequest.score)
 }
formUrlEncoded.append('errorMessage', adminMachineEvaluationResultRequest.errorMessage)
formUrlEncoded.append('status', adminMachineEvaluationResultRequest.status)
formUrlEncoded.append('metrics', adminMachineEvaluationResultRequest.metrics)
if(adminMachineEvaluationResultRequest.additionalMessage !== undefined) {
 formUrlEncoded.append('additionalMessage', adminMachineEvaluationResultRequest.additionalMessage)
 }

      return orvalAxiosAdapter<AdminMachineEvaluationResultRequest>(
      {url: `/api/v1/admin-machine/competitions/${competitionId}/submissions/${submissionId}/evaluation-results/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminMachineCompetitionsSubmissionsEvaluationResultsCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMachineCompetitionsSubmissionsEvaluationResultsCreate>>, TError,{competitionId: number;submissionId: string;data: AdminMachineEvaluationResultRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminMachineCompetitionsSubmissionsEvaluationResultsCreate>>, TError,{competitionId: number;submissionId: string;data: AdminMachineEvaluationResultRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMachineCompetitionsSubmissionsEvaluationResultsCreate>>, {competitionId: number;submissionId: string;data: AdminMachineEvaluationResultRequest}> = (props) => {
          const {competitionId,submissionId,data} = props ?? {};

          return  adminMachineCompetitionsSubmissionsEvaluationResultsCreate(competitionId,submissionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminMachineCompetitionsSubmissionsEvaluationResultsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMachineCompetitionsSubmissionsEvaluationResultsCreate>>>
    export type AdminMachineCompetitionsSubmissionsEvaluationResultsCreateMutationBody = AdminMachineEvaluationResultRequest
    export type AdminMachineCompetitionsSubmissionsEvaluationResultsCreateMutationError = BadRequest | Unauthorized | Forbidden | Conflict

    export const useAdminMachineCompetitionsSubmissionsEvaluationResultsCreate = <TError = BadRequest | Unauthorized | Forbidden | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMachineCompetitionsSubmissionsEvaluationResultsCreate>>, TError,{competitionId: number;submissionId: string;data: AdminMachineEvaluationResultRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminMachineCompetitionsSubmissionsEvaluationResultsCreate>>,
        TError,
        {competitionId: number;submissionId: string;data: AdminMachineEvaluationResultRequest},
        TContext
      > => {

      const mutationOptions = getAdminMachineCompetitionsSubmissionsEvaluationResultsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 推論が終わったことをこのエンドポイントに通知し、
後段の精度評価処理をリクエストするためのView.
本番環境で使用する前にDBのステータス更新などを行うロジックを
実装すること

POST: 推論が終わったことを通知し、後段の精度評価処理をリクエスト
 */
export const adminMachineInferenceResultsCreate = (
    adminMachineInferenceResultRequest: AdminMachineInferenceResultRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('message', JSON.stringify(adminMachineInferenceResultRequest.message));

      return orvalAxiosAdapter<AdminMachineInferenceResultRequest>(
      {url: `/api/v1/admin-machine/inference-results/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminMachineInferenceResultsCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMachineInferenceResultsCreate>>, TError,{data: AdminMachineInferenceResultRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminMachineInferenceResultsCreate>>, TError,{data: AdminMachineInferenceResultRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMachineInferenceResultsCreate>>, {data: AdminMachineInferenceResultRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminMachineInferenceResultsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminMachineInferenceResultsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMachineInferenceResultsCreate>>>
    export type AdminMachineInferenceResultsCreateMutationBody = AdminMachineInferenceResultRequest
    export type AdminMachineInferenceResultsCreateMutationError = BadRequest | Unauthorized | Forbidden | Conflict

    export const useAdminMachineInferenceResultsCreate = <TError = BadRequest | Unauthorized | Forbidden | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMachineInferenceResultsCreate>>, TError,{data: AdminMachineInferenceResultRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminMachineInferenceResultsCreate>>,
        TError,
        {data: AdminMachineInferenceResultRequest},
        TContext
      > => {

      const mutationOptions = getAdminMachineInferenceResultsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペのファイルを取得するためのViewクラス

GET: コンペのファイル一覧を取得

POST: ファイルを作成する。

PATCH: コンペのファイルを更新するまたは削除する
 */
export const adminAttachementList = (
    competitionId: number,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminAttachment[]>(
      {url: `/api/v1/admin/attachement/${competitionId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminAttachementListQueryKey = (competitionId: number,) => {
    return [`/api/v1/admin/attachement/${competitionId}/`] as const;
    }

    
export const getAdminAttachementListQueryOptions = <TData = Awaited<ReturnType<typeof adminAttachementList>>, TError = Unauthorized | NotFound>(competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttachementList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAttachementListQueryKey(competitionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAttachementList>>> = ({ signal }) => adminAttachementList(competitionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(competitionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAttachementList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminAttachementListQueryResult = NonNullable<Awaited<ReturnType<typeof adminAttachementList>>>
export type AdminAttachementListQueryError = Unauthorized | NotFound


export function useAdminAttachementList<TData = Awaited<ReturnType<typeof adminAttachementList>>, TError = Unauthorized | NotFound>(
 competitionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttachementList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttachementList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminAttachementList<TData = Awaited<ReturnType<typeof adminAttachementList>>, TError = Unauthorized | NotFound>(
 competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttachementList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttachementList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminAttachementList<TData = Awaited<ReturnType<typeof adminAttachementList>>, TError = Unauthorized | NotFound>(
 competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttachementList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminAttachementList<TData = Awaited<ReturnType<typeof adminAttachementList>>, TError = Unauthorized | NotFound>(
 competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttachementList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminAttachementListQueryOptions(competitionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者がコンペのファイルを取得するためのViewクラス

GET: コンペのファイル一覧を取得

POST: ファイルを作成する。

PATCH: コンペのファイルを更新するまたは削除する
 */
export const adminAttachementCreate = (
    competitionId: number,
    adminAttachmentRequest: AdminAttachmentRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('file', adminAttachmentRequest.file)
formUrlEncoded.append('name', adminAttachmentRequest.name)
if(adminAttachmentRequest.displaySize !== undefined) {
 formUrlEncoded.append('displaySize', adminAttachmentRequest.displaySize)
 }
if(adminAttachmentRequest.fileName !== undefined) {
 formUrlEncoded.append('fileName', adminAttachmentRequest.fileName)
 }
if(adminAttachmentRequest.description !== undefined) {
 formUrlEncoded.append('description', adminAttachmentRequest.description)
 }
if(adminAttachmentRequest.sortNumber !== undefined) {
 formUrlEncoded.append('sortNumber', adminAttachmentRequest.sortNumber.toString())
 }

      return orvalAxiosAdapter<AdminAttachment>(
      {url: `/api/v1/admin/attachement/${competitionId}/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminAttachementCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementCreate>>, TError,{competitionId: number;data: AdminAttachmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAttachementCreate>>, TError,{competitionId: number;data: AdminAttachmentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttachementCreate>>, {competitionId: number;data: AdminAttachmentRequest}> = (props) => {
          const {competitionId,data} = props ?? {};

          return  adminAttachementCreate(competitionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAttachementCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttachementCreate>>>
    export type AdminAttachementCreateMutationBody = AdminAttachmentRequest
    export type AdminAttachementCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminAttachementCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementCreate>>, TError,{competitionId: number;data: AdminAttachmentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAttachementCreate>>,
        TError,
        {competitionId: number;data: AdminAttachmentRequest},
        TContext
      > => {

      const mutationOptions = getAdminAttachementCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペのファイルを取得するためのViewクラス

GET: コンペのファイル一覧を取得

POST: ファイルを作成する。

PATCH: コンペのファイルを更新するまたは削除する
 */
export const adminAttachementPartialUpdate = (
    competitionId: number,
    patchedAdminAttachmentPatchRequest: PatchedAdminAttachmentPatchRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminAttachmentPatchRequest.attachmentId !== undefined) {
 formUrlEncoded.append('attachmentId', patchedAdminAttachmentPatchRequest.attachmentId)
 }
if(patchedAdminAttachmentPatchRequest.deleteFlag !== undefined) {
 formUrlEncoded.append('deleteFlag', patchedAdminAttachmentPatchRequest.deleteFlag.toString())
 }
if(patchedAdminAttachmentPatchRequest.file !== undefined) {
 formUrlEncoded.append('file', patchedAdminAttachmentPatchRequest.file)
 }
if(patchedAdminAttachmentPatchRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedAdminAttachmentPatchRequest.name)
 }
if(patchedAdminAttachmentPatchRequest.displaySize !== undefined) {
 formUrlEncoded.append('displaySize', patchedAdminAttachmentPatchRequest.displaySize)
 }
if(patchedAdminAttachmentPatchRequest.fileName !== undefined) {
 formUrlEncoded.append('fileName', patchedAdminAttachmentPatchRequest.fileName)
 }
if(patchedAdminAttachmentPatchRequest.description !== undefined) {
 formUrlEncoded.append('description', patchedAdminAttachmentPatchRequest.description)
 }
if(patchedAdminAttachmentPatchRequest.sortNumber !== undefined) {
 formUrlEncoded.append('sortNumber', patchedAdminAttachmentPatchRequest.sortNumber.toString())
 }

      return orvalAxiosAdapter<AdminAttachment | void>(
      {url: `/api/v1/admin/attachement/${competitionId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminAttachementPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementPartialUpdate>>, TError,{competitionId: number;data: PatchedAdminAttachmentPatchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAttachementPartialUpdate>>, TError,{competitionId: number;data: PatchedAdminAttachmentPatchRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttachementPartialUpdate>>, {competitionId: number;data: PatchedAdminAttachmentPatchRequest}> = (props) => {
          const {competitionId,data} = props ?? {};

          return  adminAttachementPartialUpdate(competitionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAttachementPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttachementPartialUpdate>>>
    export type AdminAttachementPartialUpdateMutationBody = PatchedAdminAttachmentPatchRequest
    export type AdminAttachementPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminAttachementPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementPartialUpdate>>, TError,{competitionId: number;data: PatchedAdminAttachmentPatchRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAttachementPartialUpdate>>,
        TError,
        {competitionId: number;data: PatchedAdminAttachmentPatchRequest},
        TContext
      > => {

      const mutationOptions = getAdminAttachementPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペのファイルを作成するためのView

POST: ファイルを作成する。
 */
export const adminAttachementsUpdate = (
    adminAttachmentRequest: AdminAttachmentRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('file', adminAttachmentRequest.file)
formUrlEncoded.append('name', adminAttachmentRequest.name)
if(adminAttachmentRequest.displaySize !== undefined) {
 formUrlEncoded.append('displaySize', adminAttachmentRequest.displaySize)
 }
if(adminAttachmentRequest.fileName !== undefined) {
 formUrlEncoded.append('fileName', adminAttachmentRequest.fileName)
 }
if(adminAttachmentRequest.description !== undefined) {
 formUrlEncoded.append('description', adminAttachmentRequest.description)
 }
if(adminAttachmentRequest.sortNumber !== undefined) {
 formUrlEncoded.append('sortNumber', adminAttachmentRequest.sortNumber.toString())
 }

      return orvalAxiosAdapter<AdminAttachment>(
      {url: `/api/v1/admin/attachements/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminAttachementsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementsUpdate>>, TError,{data: AdminAttachmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAttachementsUpdate>>, TError,{data: AdminAttachmentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttachementsUpdate>>, {data: AdminAttachmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminAttachementsUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAttachementsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttachementsUpdate>>>
    export type AdminAttachementsUpdateMutationBody = AdminAttachmentRequest
    export type AdminAttachementsUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminAttachementsUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementsUpdate>>, TError,{data: AdminAttachmentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAttachementsUpdate>>,
        TError,
        {data: AdminAttachmentRequest},
        TContext
      > => {

      const mutationOptions = getAdminAttachementsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペのファイルを作成するためのView

POST: ファイルを作成する。
 */
export const adminAttachementsPartialUpdate = (
    patchedAdminAttachmentRequest: PatchedAdminAttachmentRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminAttachmentRequest.file !== undefined) {
 formUrlEncoded.append('file', patchedAdminAttachmentRequest.file)
 }
if(patchedAdminAttachmentRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedAdminAttachmentRequest.name)
 }
if(patchedAdminAttachmentRequest.displaySize !== undefined) {
 formUrlEncoded.append('displaySize', patchedAdminAttachmentRequest.displaySize)
 }
if(patchedAdminAttachmentRequest.fileName !== undefined) {
 formUrlEncoded.append('fileName', patchedAdminAttachmentRequest.fileName)
 }
if(patchedAdminAttachmentRequest.description !== undefined) {
 formUrlEncoded.append('description', patchedAdminAttachmentRequest.description)
 }
if(patchedAdminAttachmentRequest.sortNumber !== undefined) {
 formUrlEncoded.append('sortNumber', patchedAdminAttachmentRequest.sortNumber.toString())
 }

      return orvalAxiosAdapter<AdminAttachment>(
      {url: `/api/v1/admin/attachements/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminAttachementsPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementsPartialUpdate>>, TError,{data: PatchedAdminAttachmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAttachementsPartialUpdate>>, TError,{data: PatchedAdminAttachmentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttachementsPartialUpdate>>, {data: PatchedAdminAttachmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminAttachementsPartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAttachementsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttachementsPartialUpdate>>>
    export type AdminAttachementsPartialUpdateMutationBody = PatchedAdminAttachmentRequest
    export type AdminAttachementsPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminAttachementsPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttachementsPartialUpdate>>, TError,{data: PatchedAdminAttachmentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAttachementsPartialUpdate>>,
        TError,
        {data: PatchedAdminAttachmentRequest},
        TContext
      > => {

      const mutationOptions = getAdminAttachementsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペを作成するためのView

POST: コンペを作成する。

GET: コンペ一覧を取得
 */
export const adminCompettionsList = (
    params?: AdminCompettionsListParams,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminCompetitions[]>(
      {url: `/api/v1/admin/compettions/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminCompettionsListQueryKey = (params?: AdminCompettionsListParams,) => {
    return [`/api/v1/admin/compettions/`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminCompettionsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCompettionsList>>, TError = Unauthorized | NotFound>(params?: AdminCompettionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCompettionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCompettionsList>>> = ({ signal }) => adminCompettionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCompettionsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCompettionsList>>>
export type AdminCompettionsListQueryError = Unauthorized | NotFound


export function useAdminCompettionsList<TData = Awaited<ReturnType<typeof adminCompettionsList>>, TError = Unauthorized | NotFound>(
 params: undefined |  AdminCompettionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCompettionsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminCompettionsList<TData = Awaited<ReturnType<typeof adminCompettionsList>>, TError = Unauthorized | NotFound>(
 params?: AdminCompettionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCompettionsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminCompettionsList<TData = Awaited<ReturnType<typeof adminCompettionsList>>, TError = Unauthorized | NotFound>(
 params?: AdminCompettionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminCompettionsList<TData = Awaited<ReturnType<typeof adminCompettionsList>>, TError = Unauthorized | NotFound>(
 params?: AdminCompettionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminCompettionsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者がコンペを作成するためのView

POST: コンペを作成する。

GET: コンペ一覧を取得
 */
export const adminCompettionsCreate = (
    adminCompetitionRequest: AdminCompetitionRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('title', adminCompetitionRequest.title)
if(adminCompetitionRequest.shortDescription !== undefined) {
 formUrlEncoded.append('shortDescription', adminCompetitionRequest.shortDescription)
 }
if(adminCompetitionRequest.description !== undefined) {
 formUrlEncoded.append('description', adminCompetitionRequest.description)
 }
if(adminCompetitionRequest.attachmentNote !== undefined) {
 formUrlEncoded.append('attachmentNote', adminCompetitionRequest.attachmentNote)
 }
if(adminCompetitionRequest.submissionNote !== undefined) {
 formUrlEncoded.append('submissionNote', adminCompetitionRequest.submissionNote)
 }
if(adminCompetitionRequest.evaluationMetricsId !== undefined) {
 formUrlEncoded.append('evaluationMetricsId', adminCompetitionRequest.evaluationMetricsId)
 }
if(adminCompetitionRequest.submissionType !== undefined) {
 formUrlEncoded.append('submissionType', adminCompetitionRequest.submissionType)
 }
if(adminCompetitionRequest.competitionType !== undefined) {
 formUrlEncoded.append('competitionType', adminCompetitionRequest.competitionType)
 }
if(adminCompetitionRequest.mainImage !== undefined) {
 formUrlEncoded.append('mainImage', adminCompetitionRequest.mainImage)
 }
if(adminCompetitionRequest.subImage !== undefined) {
 formUrlEncoded.append('subImage', adminCompetitionRequest.subImage)
 }
if(adminCompetitionRequest.gtData !== undefined) {
 formUrlEncoded.append('gtData', adminCompetitionRequest.gtData)
 }
if(adminCompetitionRequest.testData !== undefined) {
 formUrlEncoded.append('testData', adminCompetitionRequest.testData)
 }

      return orvalAxiosAdapter<AdminCompetitions>(
      {url: `/api/v1/admin/compettions/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminCompettionsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsCreate>>, TError,{data: AdminCompetitionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsCreate>>, TError,{data: AdminCompetitionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCompettionsCreate>>, {data: AdminCompetitionRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminCompettionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCompettionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCompettionsCreate>>>
    export type AdminCompettionsCreateMutationBody = AdminCompetitionRequest
    export type AdminCompettionsCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminCompettionsCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsCreate>>, TError,{data: AdminCompetitionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminCompettionsCreate>>,
        TError,
        {data: AdminCompetitionRequest},
        TContext
      > => {

      const mutationOptions = getAdminCompettionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペの詳細を取得するView

GET: コンペ詳細を取得

PUT: コンペ情報を更新する。

PATCH: コンペ情報を部分的に更新する。
 */
export const adminCompettionsRetrieve = (
    competitionId: number,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminCompetitions>(
      {url: `/api/v1/admin/compettions/${competitionId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminCompettionsRetrieveQueryKey = (competitionId: number,) => {
    return [`/api/v1/admin/compettions/${competitionId}/`] as const;
    }

    
export const getAdminCompettionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError = NotFound>(competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCompettionsRetrieveQueryKey(competitionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCompettionsRetrieve>>> = ({ signal }) => adminCompettionsRetrieve(competitionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(competitionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCompettionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCompettionsRetrieve>>>
export type AdminCompettionsRetrieveQueryError = NotFound


export function useAdminCompettionsRetrieve<TData = Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError = NotFound>(
 competitionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCompettionsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminCompettionsRetrieve<TData = Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError = NotFound>(
 competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCompettionsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminCompettionsRetrieve<TData = Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError = NotFound>(
 competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminCompettionsRetrieve<TData = Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError = NotFound>(
 competitionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCompettionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminCompettionsRetrieveQueryOptions(competitionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者がコンペの詳細を取得するView

GET: コンペ詳細を取得

PUT: コンペ情報を更新する。

PATCH: コンペ情報を部分的に更新する。
 */
export const adminCompettionsUpdate = (
    competitionId: number,
    adminCompetitionRequest: AdminCompetitionRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('title', adminCompetitionRequest.title)
if(adminCompetitionRequest.shortDescription !== undefined) {
 formUrlEncoded.append('shortDescription', adminCompetitionRequest.shortDescription)
 }
if(adminCompetitionRequest.description !== undefined) {
 formUrlEncoded.append('description', adminCompetitionRequest.description)
 }
if(adminCompetitionRequest.attachmentNote !== undefined) {
 formUrlEncoded.append('attachmentNote', adminCompetitionRequest.attachmentNote)
 }
if(adminCompetitionRequest.submissionNote !== undefined) {
 formUrlEncoded.append('submissionNote', adminCompetitionRequest.submissionNote)
 }
if(adminCompetitionRequest.evaluationMetricsId !== undefined) {
 formUrlEncoded.append('evaluationMetricsId', adminCompetitionRequest.evaluationMetricsId)
 }
if(adminCompetitionRequest.submissionType !== undefined) {
 formUrlEncoded.append('submissionType', adminCompetitionRequest.submissionType)
 }
if(adminCompetitionRequest.competitionType !== undefined) {
 formUrlEncoded.append('competitionType', adminCompetitionRequest.competitionType)
 }
if(adminCompetitionRequest.mainImage !== undefined) {
 formUrlEncoded.append('mainImage', adminCompetitionRequest.mainImage)
 }
if(adminCompetitionRequest.subImage !== undefined) {
 formUrlEncoded.append('subImage', adminCompetitionRequest.subImage)
 }
if(adminCompetitionRequest.gtData !== undefined) {
 formUrlEncoded.append('gtData', adminCompetitionRequest.gtData)
 }
if(adminCompetitionRequest.testData !== undefined) {
 formUrlEncoded.append('testData', adminCompetitionRequest.testData)
 }

      return orvalAxiosAdapter<AdminCompetitions>(
      {url: `/api/v1/admin/compettions/${competitionId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminCompettionsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsUpdate>>, TError,{competitionId: number;data: AdminCompetitionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsUpdate>>, TError,{competitionId: number;data: AdminCompetitionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCompettionsUpdate>>, {competitionId: number;data: AdminCompetitionRequest}> = (props) => {
          const {competitionId,data} = props ?? {};

          return  adminCompettionsUpdate(competitionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCompettionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCompettionsUpdate>>>
    export type AdminCompettionsUpdateMutationBody = AdminCompetitionRequest
    export type AdminCompettionsUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminCompettionsUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsUpdate>>, TError,{competitionId: number;data: AdminCompetitionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminCompettionsUpdate>>,
        TError,
        {competitionId: number;data: AdminCompetitionRequest},
        TContext
      > => {

      const mutationOptions = getAdminCompettionsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がコンペの詳細を取得するView

GET: コンペ詳細を取得

PUT: コンペ情報を更新する。

PATCH: コンペ情報を部分的に更新する。
 */
export const adminCompettionsPartialUpdate = (
    competitionId: number,
    patchedAdminCompetitionRequest: PatchedAdminCompetitionRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminCompetitionRequest.title !== undefined) {
 formUrlEncoded.append('title', patchedAdminCompetitionRequest.title)
 }
if(patchedAdminCompetitionRequest.shortDescription !== undefined) {
 formUrlEncoded.append('shortDescription', patchedAdminCompetitionRequest.shortDescription)
 }
if(patchedAdminCompetitionRequest.description !== undefined) {
 formUrlEncoded.append('description', patchedAdminCompetitionRequest.description)
 }
if(patchedAdminCompetitionRequest.attachmentNote !== undefined) {
 formUrlEncoded.append('attachmentNote', patchedAdminCompetitionRequest.attachmentNote)
 }
if(patchedAdminCompetitionRequest.submissionNote !== undefined) {
 formUrlEncoded.append('submissionNote', patchedAdminCompetitionRequest.submissionNote)
 }
if(patchedAdminCompetitionRequest.evaluationMetricsId !== undefined) {
 formUrlEncoded.append('evaluationMetricsId', patchedAdminCompetitionRequest.evaluationMetricsId)
 }
if(patchedAdminCompetitionRequest.submissionType !== undefined) {
 formUrlEncoded.append('submissionType', patchedAdminCompetitionRequest.submissionType)
 }
if(patchedAdminCompetitionRequest.competitionType !== undefined) {
 formUrlEncoded.append('competitionType', patchedAdminCompetitionRequest.competitionType)
 }
if(patchedAdminCompetitionRequest.mainImage !== undefined) {
 formUrlEncoded.append('mainImage', patchedAdminCompetitionRequest.mainImage)
 }
if(patchedAdminCompetitionRequest.subImage !== undefined) {
 formUrlEncoded.append('subImage', patchedAdminCompetitionRequest.subImage)
 }
if(patchedAdminCompetitionRequest.gtData !== undefined) {
 formUrlEncoded.append('gtData', patchedAdminCompetitionRequest.gtData)
 }
if(patchedAdminCompetitionRequest.testData !== undefined) {
 formUrlEncoded.append('testData', patchedAdminCompetitionRequest.testData)
 }

      return orvalAxiosAdapter<AdminCompetitions>(
      {url: `/api/v1/admin/compettions/${competitionId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminCompettionsPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsPartialUpdate>>, TError,{competitionId: number;data: PatchedAdminCompetitionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsPartialUpdate>>, TError,{competitionId: number;data: PatchedAdminCompetitionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCompettionsPartialUpdate>>, {competitionId: number;data: PatchedAdminCompetitionRequest}> = (props) => {
          const {competitionId,data} = props ?? {};

          return  adminCompettionsPartialUpdate(competitionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCompettionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCompettionsPartialUpdate>>>
    export type AdminCompettionsPartialUpdateMutationBody = PatchedAdminCompetitionRequest
    export type AdminCompettionsPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminCompettionsPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCompettionsPartialUpdate>>, TError,{competitionId: number;data: PatchedAdminCompetitionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminCompettionsPartialUpdate>>,
        TError,
        {competitionId: number;data: PatchedAdminCompetitionRequest},
        TContext
      > => {

      const mutationOptions = getAdminCompettionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がユーザーをCSVファイルから作成するためのView
POST: ユーザーを作成する。この段階ではまだFirebase Authenticationへの登録は行われていない。
 */
export const adminCsvUsersCreate = (
    adminCSVUserRequest: AdminCSVUserRequest,
 ) => {
      
      const formData = new FormData();
formData.append('file', adminCSVUserRequest.file)

      return orvalAxiosAdapter<AdminCSVUserResult[]>(
      {url: `/api/v1/admin/csv_users/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getAdminCsvUsersCreateMutationOptions = <TError = BadRequest | Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCsvUsersCreate>>, TError,{data: AdminCSVUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminCsvUsersCreate>>, TError,{data: AdminCSVUserRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCsvUsersCreate>>, {data: AdminCSVUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminCsvUsersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCsvUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCsvUsersCreate>>>
    export type AdminCsvUsersCreateMutationBody = AdminCSVUserRequest
    export type AdminCsvUsersCreateMutationError = BadRequest | Unauthorized

    export const useAdminCsvUsersCreate = <TError = BadRequest | Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCsvUsersCreate>>, TError,{data: AdminCSVUserRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminCsvUsersCreate>>,
        TError,
        {data: AdminCSVUserRequest},
        TContext
      > => {

      const mutationOptions = getAdminCsvUsersCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が部署を作成するためのView

POST: 部署を作成する。

GET: 部署一覧を取得

PUT: 部署情報を更新する。

PATCH: 部署情報を部分的に更新する。
 */
export const adminDepartmentList = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminDepartment[]>(
      {url: `/api/v1/admin/departments/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminDepartmentListQueryKey = () => {
    return [`/api/v1/admin/departments/`] as const;
    }

    
export const getAdminDepartmentListQueryOptions = <TData = Awaited<ReturnType<typeof adminDepartmentList>>, TError = Unauthorized | NotFound>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDepartmentList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminDepartmentListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDepartmentList>>> = ({ signal }) => adminDepartmentList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminDepartmentList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminDepartmentListQueryResult = NonNullable<Awaited<ReturnType<typeof adminDepartmentList>>>
export type AdminDepartmentListQueryError = Unauthorized | NotFound


export function useAdminDepartmentList<TData = Awaited<ReturnType<typeof adminDepartmentList>>, TError = Unauthorized | NotFound>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDepartmentList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDepartmentList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminDepartmentList<TData = Awaited<ReturnType<typeof adminDepartmentList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDepartmentList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDepartmentList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminDepartmentList<TData = Awaited<ReturnType<typeof adminDepartmentList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDepartmentList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminDepartmentList<TData = Awaited<ReturnType<typeof adminDepartmentList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDepartmentList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminDepartmentListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が部署を作成するためのView

POST: 部署を作成する。

GET: 部署一覧を取得

PUT: 部署情報を更新する。

PATCH: 部署情報を部分的に更新する。
 */
export const adminDepartmentsCreate = (
    adminDepartmentRequest: AdminDepartmentRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminDepartmentRequest.name)
formUrlEncoded.append('organization', adminDepartmentRequest.organization)

      return orvalAxiosAdapter<AdminDepartment>(
      {url: `/api/v1/admin/departments/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminDepartmentsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsCreate>>, TError,{data: AdminDepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsCreate>>, TError,{data: AdminDepartmentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDepartmentsCreate>>, {data: AdminDepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminDepartmentsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDepartmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminDepartmentsCreate>>>
    export type AdminDepartmentsCreateMutationBody = AdminDepartmentRequest
    export type AdminDepartmentsCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminDepartmentsCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsCreate>>, TError,{data: AdminDepartmentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminDepartmentsCreate>>,
        TError,
        {data: AdminDepartmentRequest},
        TContext
      > => {

      const mutationOptions = getAdminDepartmentsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が部署を作成するためのView

POST: 部署を作成する。

GET: 部署一覧を取得

PUT: 部署情報を更新する。

PATCH: 部署情報を部分的に更新する。
 */
export const adminDepartmentsUpdate = (
    adminDepartmentRequest: AdminDepartmentRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminDepartmentRequest.name)
formUrlEncoded.append('organization', adminDepartmentRequest.organization)

      return orvalAxiosAdapter<AdminDepartment>(
      {url: `/api/v1/admin/departments/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminDepartmentsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsUpdate>>, TError,{data: AdminDepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsUpdate>>, TError,{data: AdminDepartmentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDepartmentsUpdate>>, {data: AdminDepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminDepartmentsUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDepartmentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminDepartmentsUpdate>>>
    export type AdminDepartmentsUpdateMutationBody = AdminDepartmentRequest
    export type AdminDepartmentsUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminDepartmentsUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsUpdate>>, TError,{data: AdminDepartmentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminDepartmentsUpdate>>,
        TError,
        {data: AdminDepartmentRequest},
        TContext
      > => {

      const mutationOptions = getAdminDepartmentsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が部署を作成するためのView

POST: 部署を作成する。

GET: 部署一覧を取得

PUT: 部署情報を更新する。

PATCH: 部署情報を部分的に更新する。
 */
export const adminDepartmentsPartialUpdate = (
    patchedAdminDepartmentRequest: PatchedAdminDepartmentRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminDepartmentRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedAdminDepartmentRequest.name)
 }
if(patchedAdminDepartmentRequest.organization !== undefined) {
 formUrlEncoded.append('organization', patchedAdminDepartmentRequest.organization)
 }

      return orvalAxiosAdapter<AdminDepartment>(
      {url: `/api/v1/admin/departments/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminDepartmentsPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsPartialUpdate>>, TError,{data: PatchedAdminDepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsPartialUpdate>>, TError,{data: PatchedAdminDepartmentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDepartmentsPartialUpdate>>, {data: PatchedAdminDepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminDepartmentsPartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDepartmentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminDepartmentsPartialUpdate>>>
    export type AdminDepartmentsPartialUpdateMutationBody = PatchedAdminDepartmentRequest
    export type AdminDepartmentsPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminDepartmentsPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDepartmentsPartialUpdate>>, TError,{data: PatchedAdminDepartmentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminDepartmentsPartialUpdate>>,
        TError,
        {data: PatchedAdminDepartmentRequest},
        TContext
      > => {

      const mutationOptions = getAdminDepartmentsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が企業の部署を取得するためのViewクラス

GET: 企業の部署一覧を取得
 */
export const adminOrganizationDepartmentList = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminDepartment[]>(
      {url: `/api/v1/admin/departments/${organizationId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationDepartmentListQueryKey = (organizationId: string,) => {
    return [`/api/v1/admin/departments/${organizationId}/`] as const;
    }

    
export const getAdminOrganizationDepartmentListQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError = Unauthorized | NotFound>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationDepartmentListQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>> = ({ signal }) => adminOrganizationDepartmentList(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminOrganizationDepartmentListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>>
export type AdminOrganizationDepartmentListQueryError = Unauthorized | NotFound


export function useAdminOrganizationDepartmentList<TData = Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationDepartmentList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationDepartmentList<TData = Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationDepartmentList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationDepartmentList<TData = Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminOrganizationDepartmentList<TData = Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationDepartmentList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminOrganizationDepartmentListQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が評価指標を取得するためのView

GET: 評価指標一覧を取得
 */
export const adminEvaluationMetricsList = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<EvaluationMetrics[]>(
      {url: `/api/v1/admin/evaluation-metrics/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminEvaluationMetricsListQueryKey = () => {
    return [`/api/v1/admin/evaluation-metrics/`] as const;
    }

    
export const getAdminEvaluationMetricsListQueryOptions = <TData = Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError = Unauthorized | NotFound>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminEvaluationMetricsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminEvaluationMetricsList>>> = ({ signal }) => adminEvaluationMetricsList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminEvaluationMetricsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminEvaluationMetricsList>>>
export type AdminEvaluationMetricsListQueryError = Unauthorized | NotFound


export function useAdminEvaluationMetricsList<TData = Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError = Unauthorized | NotFound>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEvaluationMetricsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminEvaluationMetricsList<TData = Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEvaluationMetricsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminEvaluationMetricsList<TData = Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminEvaluationMetricsList<TData = Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEvaluationMetricsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminEvaluationMetricsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が資格を作成するためのView

POST: 資格を作成する。

GET: 資格一覧を取得
 */
export const adminLicenseList = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminLicense[]>(
      {url: `/api/v1/admin/licenses/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminLicenseListQueryKey = () => {
    return [`/api/v1/admin/licenses/`] as const;
    }

    
export const getAdminLicenseListQueryOptions = <TData = Awaited<ReturnType<typeof adminLicenseList>>, TError = Unauthorized | NotFound>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicenseList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLicenseListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLicenseList>>> = ({ signal }) => adminLicenseList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLicenseList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminLicenseListQueryResult = NonNullable<Awaited<ReturnType<typeof adminLicenseList>>>
export type AdminLicenseListQueryError = Unauthorized | NotFound


export function useAdminLicenseList<TData = Awaited<ReturnType<typeof adminLicenseList>>, TError = Unauthorized | NotFound>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicenseList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicenseList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicenseList<TData = Awaited<ReturnType<typeof adminLicenseList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicenseList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicenseList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicenseList<TData = Awaited<ReturnType<typeof adminLicenseList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicenseList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminLicenseList<TData = Awaited<ReturnType<typeof adminLicenseList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicenseList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminLicenseListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が資格を作成するためのView

POST: 資格を作成する。

GET: 資格一覧を取得
 */
export const adminLicensesCreate = (
    adminLicenseRequest: AdminLicenseRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('organization', adminLicenseRequest.organization)
formUrlEncoded.append('competition', adminLicenseRequest.competition)
formUrlEncoded.append('startDatetime', adminLicenseRequest.startDatetime)
formUrlEncoded.append('endDatetime', adminLicenseRequest.endDatetime)
if(adminLicenseRequest.name !== undefined) {
 formUrlEncoded.append('name', adminLicenseRequest.name)
 }
formUrlEncoded.append('isValid', adminLicenseRequest.isValid.toString())
if(adminLicenseRequest.lbHidingStartDatetime !== undefined && adminLicenseRequest.lbHidingStartDatetime !== null) {
 formUrlEncoded.append('lbHidingStartDatetime', adminLicenseRequest.lbHidingStartDatetime)
 }
if(adminLicenseRequest.lbHidingEndDatetime !== undefined && adminLicenseRequest.lbHidingEndDatetime !== null) {
 formUrlEncoded.append('lbHidingEndDatetime', adminLicenseRequest.lbHidingEndDatetime)
 }
if(adminLicenseRequest.includeStaffInScores !== undefined) {
 formUrlEncoded.append('includeStaffInScores', adminLicenseRequest.includeStaffInScores.toString())
 }
if(adminLicenseRequest.includeObserversInScores !== undefined) {
 formUrlEncoded.append('includeObserversInScores', adminLicenseRequest.includeObserversInScores.toString())
 }

      return orvalAxiosAdapter<AdminLicense>(
      {url: `/api/v1/admin/licenses/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminLicensesCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesCreate>>, TError,{data: AdminLicenseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesCreate>>, TError,{data: AdminLicenseRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesCreate>>, {data: AdminLicenseRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminLicensesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesCreate>>>
    export type AdminLicensesCreateMutationBody = AdminLicenseRequest
    export type AdminLicensesCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminLicensesCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesCreate>>, TError,{data: AdminLicenseRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesCreate>>,
        TError,
        {data: AdminLicenseRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が企業の資格を取得するためのViewクラス

GET: 企業の資格一覧を取得
 */
export const adminOrganizationLicenseList = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminLicense[]>(
      {url: `/api/v1/admin/licenses/${organizationId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationLicenseListQueryKey = (organizationId: string,) => {
    return [`/api/v1/admin/licenses/${organizationId}/`] as const;
    }

    
export const getAdminOrganizationLicenseListQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError = Unauthorized | NotFound>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationLicenseListQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationLicenseList>>> = ({ signal }) => adminOrganizationLicenseList(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminOrganizationLicenseListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationLicenseList>>>
export type AdminOrganizationLicenseListQueryError = Unauthorized | NotFound


export function useAdminOrganizationLicenseList<TData = Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationLicenseList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationLicenseList<TData = Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationLicenseList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationLicenseList<TData = Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminOrganizationLicenseList<TData = Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationLicenseList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminOrganizationLicenseListQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が資格詳細を更新するためのView

GET: 資格情報を取得する。

PUT: 資格情報を更新する。

PATCH: 資格情報を部分的に更新する。
 */
export const adminLicensesDetailRetrieve = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminLicense>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminLicensesDetailRetrieveQueryKey = (licenseId: string,) => {
    return [`/api/v1/admin/licenses_detail/${licenseId}/`] as const;
    }

    
export const getAdminLicensesDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError = BadRequest | Unauthorized | NotFound>(licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLicensesDetailRetrieveQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>> = ({ signal }) => adminLicensesDetailRetrieve(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminLicensesDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>>
export type AdminLicensesDetailRetrieveQueryError = BadRequest | Unauthorized | NotFound


export function useAdminLicensesDetailRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError = BadRequest | Unauthorized | NotFound>(
 licenseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError = BadRequest | Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError = BadRequest | Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminLicensesDetailRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError = BadRequest | Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminLicensesDetailRetrieveQueryOptions(licenseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が資格詳細を更新するためのView

GET: 資格情報を取得する。

PUT: 資格情報を更新する。

PATCH: 資格情報を部分的に更新する。
 */
export const adminLicensesDetailUpdate = (
    licenseId: string,
    adminLicenseRequest: AdminLicenseRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('organization', adminLicenseRequest.organization)
formUrlEncoded.append('competition', adminLicenseRequest.competition)
formUrlEncoded.append('startDatetime', adminLicenseRequest.startDatetime)
formUrlEncoded.append('endDatetime', adminLicenseRequest.endDatetime)
if(adminLicenseRequest.name !== undefined) {
 formUrlEncoded.append('name', adminLicenseRequest.name)
 }
formUrlEncoded.append('isValid', adminLicenseRequest.isValid.toString())
if(adminLicenseRequest.lbHidingStartDatetime !== undefined && adminLicenseRequest.lbHidingStartDatetime !== null) {
 formUrlEncoded.append('lbHidingStartDatetime', adminLicenseRequest.lbHidingStartDatetime)
 }
if(adminLicenseRequest.lbHidingEndDatetime !== undefined && adminLicenseRequest.lbHidingEndDatetime !== null) {
 formUrlEncoded.append('lbHidingEndDatetime', adminLicenseRequest.lbHidingEndDatetime)
 }
if(adminLicenseRequest.includeStaffInScores !== undefined) {
 formUrlEncoded.append('includeStaffInScores', adminLicenseRequest.includeStaffInScores.toString())
 }
if(adminLicenseRequest.includeObserversInScores !== undefined) {
 formUrlEncoded.append('includeObserversInScores', adminLicenseRequest.includeObserversInScores.toString())
 }

      return orvalAxiosAdapter<AdminLicense>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminLicensesDetailUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailUpdate>>, TError,{licenseId: string;data: AdminLicenseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailUpdate>>, TError,{licenseId: string;data: AdminLicenseRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailUpdate>>, {licenseId: string;data: AdminLicenseRequest}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  adminLicensesDetailUpdate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailUpdate>>>
    export type AdminLicensesDetailUpdateMutationBody = AdminLicenseRequest
    export type AdminLicensesDetailUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminLicensesDetailUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailUpdate>>, TError,{licenseId: string;data: AdminLicenseRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailUpdate>>,
        TError,
        {licenseId: string;data: AdminLicenseRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が資格詳細を更新するためのView

GET: 資格情報を取得する。

PUT: 資格情報を更新する。

PATCH: 資格情報を部分的に更新する。
 */
export const adminLicensesDetailPartialUpdate = (
    licenseId: string,
    patchedAdminLicenseRequest: PatchedAdminLicenseRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminLicenseRequest.organization !== undefined) {
 formUrlEncoded.append('organization', patchedAdminLicenseRequest.organization)
 }
if(patchedAdminLicenseRequest.competition !== undefined) {
 formUrlEncoded.append('competition', patchedAdminLicenseRequest.competition)
 }
if(patchedAdminLicenseRequest.startDatetime !== undefined) {
 formUrlEncoded.append('startDatetime', patchedAdminLicenseRequest.startDatetime)
 }
if(patchedAdminLicenseRequest.endDatetime !== undefined) {
 formUrlEncoded.append('endDatetime', patchedAdminLicenseRequest.endDatetime)
 }
if(patchedAdminLicenseRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedAdminLicenseRequest.name)
 }
if(patchedAdminLicenseRequest.isValid !== undefined) {
 formUrlEncoded.append('isValid', patchedAdminLicenseRequest.isValid.toString())
 }
if(patchedAdminLicenseRequest.lbHidingStartDatetime !== undefined && patchedAdminLicenseRequest.lbHidingStartDatetime !== null) {
 formUrlEncoded.append('lbHidingStartDatetime', patchedAdminLicenseRequest.lbHidingStartDatetime)
 }
if(patchedAdminLicenseRequest.lbHidingEndDatetime !== undefined && patchedAdminLicenseRequest.lbHidingEndDatetime !== null) {
 formUrlEncoded.append('lbHidingEndDatetime', patchedAdminLicenseRequest.lbHidingEndDatetime)
 }
if(patchedAdminLicenseRequest.includeStaffInScores !== undefined) {
 formUrlEncoded.append('includeStaffInScores', patchedAdminLicenseRequest.includeStaffInScores.toString())
 }
if(patchedAdminLicenseRequest.includeObserversInScores !== undefined) {
 formUrlEncoded.append('includeObserversInScores', patchedAdminLicenseRequest.includeObserversInScores.toString())
 }

      return orvalAxiosAdapter<AdminLicense>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminLicensesDetailPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailPartialUpdate>>, TError,{licenseId: string;data: PatchedAdminLicenseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailPartialUpdate>>, TError,{licenseId: string;data: PatchedAdminLicenseRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailPartialUpdate>>, {licenseId: string;data: PatchedAdminLicenseRequest}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  adminLicensesDetailPartialUpdate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailPartialUpdate>>>
    export type AdminLicensesDetailPartialUpdateMutationBody = PatchedAdminLicenseRequest
    export type AdminLicensesDetailPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminLicensesDetailPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailPartialUpdate>>, TError,{licenseId: string;data: PatchedAdminLicenseRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailPartialUpdate>>,
        TError,
        {licenseId: string;data: PatchedAdminLicenseRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 開催回の配布物（参加者に配る秘密の値）を管理するView

GET: 配布物の一覧。値は伏せる（末尾4文字のヒントだけ）。

POST: 配布物を1件登録する（チーム単位または参加者単位）。

暗号化の鍵が無いときは、どちらも 503 を返す。
 */
export const adminLicensesDetailDistributionItemsRetrieve = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminDistributionItems>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/distribution-items/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminLicensesDetailDistributionItemsRetrieveQueryKey = (licenseId: string,) => {
    return [`/api/v1/admin/licenses_detail/${licenseId}/distribution-items/`] as const;
    }

    
export const getAdminLicensesDetailDistributionItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLicensesDetailDistributionItemsRetrieveQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>> = ({ signal }) => adminLicensesDetailDistributionItemsRetrieve(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminLicensesDetailDistributionItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>>
export type AdminLicensesDetailDistributionItemsRetrieveQueryError = Unauthorized | NotFound | BadRequest


export function useAdminLicensesDetailDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminLicensesDetailDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminLicensesDetailDistributionItemsRetrieveQueryOptions(licenseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 開催回の配布物（参加者に配る秘密の値）を管理するView

GET: 配布物の一覧。値は伏せる（末尾4文字のヒントだけ）。

POST: 配布物を1件登録する（チーム単位または参加者単位）。

暗号化の鍵が無いときは、どちらも 503 を返す。
 */
export const adminLicensesDetailDistributionItemsCreate = (
    licenseId: string,
    adminDistributionItemCreateRequest: AdminDistributionItemCreateRequest,
 ) => {
      
      
      return orvalAxiosAdapter<AdminDistributionItem>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/distribution-items/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminDistributionItemCreateRequest
    },
      );
    }
  


export const getAdminLicensesDetailDistributionItemsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCreate>>, TError,{licenseId: string;data: AdminDistributionItemCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCreate>>, TError,{licenseId: string;data: AdminDistributionItemCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCreate>>, {licenseId: string;data: AdminDistributionItemCreateRequest}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  adminLicensesDetailDistributionItemsCreate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailDistributionItemsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCreate>>>
    export type AdminLicensesDetailDistributionItemsCreateMutationBody = AdminDistributionItemCreateRequest
    export type AdminLicensesDetailDistributionItemsCreateMutationError = BadRequest | Unauthorized | NotFound | Conflict

    export const useAdminLicensesDetailDistributionItemsCreate = <TError = BadRequest | Unauthorized | NotFound | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCreate>>, TError,{licenseId: string;data: AdminDistributionItemCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCreate>>,
        TError,
        {licenseId: string;data: AdminDistributionItemCreateRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailDistributionItemsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 配布物1件を更新・削除するView

PUT: 項目名・値を直す（相手は変えられない。値を省くと値は変えない）。

DELETE: 削除する。
 */
export const adminLicensesDetailDistributionItemsUpdate = (
    licenseId: string,
    itemId: string,
    adminDistributionItemUpdateRequest: AdminDistributionItemUpdateRequest,
 ) => {
      
      
      return orvalAxiosAdapter<AdminDistributionItem>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/distribution-items/${itemId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminDistributionItemUpdateRequest
    },
      );
    }
  


export const getAdminLicensesDetailDistributionItemsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsUpdate>>, TError,{licenseId: string;itemId: string;data: AdminDistributionItemUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsUpdate>>, TError,{licenseId: string;itemId: string;data: AdminDistributionItemUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsUpdate>>, {licenseId: string;itemId: string;data: AdminDistributionItemUpdateRequest}> = (props) => {
          const {licenseId,itemId,data} = props ?? {};

          return  adminLicensesDetailDistributionItemsUpdate(licenseId,itemId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailDistributionItemsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsUpdate>>>
    export type AdminLicensesDetailDistributionItemsUpdateMutationBody = AdminDistributionItemUpdateRequest
    export type AdminLicensesDetailDistributionItemsUpdateMutationError = BadRequest | Unauthorized | NotFound | Conflict

    export const useAdminLicensesDetailDistributionItemsUpdate = <TError = BadRequest | Unauthorized | NotFound | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsUpdate>>, TError,{licenseId: string;itemId: string;data: AdminDistributionItemUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsUpdate>>,
        TError,
        {licenseId: string;itemId: string;data: AdminDistributionItemUpdateRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailDistributionItemsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 配布物1件を更新・削除するView

PUT: 項目名・値を直す（相手は変えられない。値を省くと値は変えない）。

DELETE: 削除する。
 */
export const adminLicensesDetailDistributionItemsDestroy = (
    licenseId: string,
    itemId: string,
 ) => {
      
      
      return orvalAxiosAdapter<void>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/distribution-items/${itemId}/`, method: 'DELETE'
    },
      );
    }
  


export const getAdminLicensesDetailDistributionItemsDestroyMutationOptions = <TError = Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsDestroy>>, TError,{licenseId: string;itemId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsDestroy>>, TError,{licenseId: string;itemId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsDestroy>>, {licenseId: string;itemId: string}> = (props) => {
          const {licenseId,itemId} = props ?? {};

          return  adminLicensesDetailDistributionItemsDestroy(licenseId,itemId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailDistributionItemsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsDestroy>>>
    
    export type AdminLicensesDetailDistributionItemsDestroyMutationError = Unauthorized | NotFound

    export const useAdminLicensesDetailDistributionItemsDestroy = <TError = Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsDestroy>>, TError,{licenseId: string;itemId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsDestroy>>,
        TError,
        {licenseId: string;itemId: string},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailDistributionItemsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 配布物を CSV で一括登録するView

POST: 列は「相手（チーム名 または 参加者のメール）, 項目名, 値」。
スプレッドシートの貼り付け（タブ区切り）も読める。

`dry_run=true` なら保存せず、各行が新規・更新・エラーのどれになるかを返す。

保存するときは、エラーの行が1つでもあれば何も保存せず 400 を返す。
同じ相手・同じ項目名がすでにあれば、値を上書きする。
レスポンスに値は含めない。
 */
export const adminLicensesDetailDistributionItemsCsvCreate = (
    licenseId: string,
    adminDistributionCsvRequest: AdminDistributionCsvRequest,
 ) => {
      
      
      return orvalAxiosAdapter<AdminDistributionCsvResult>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/distribution-items/csv/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminDistributionCsvRequest
    },
      );
    }
  


export const getAdminLicensesDetailDistributionItemsCsvCreateMutationOptions = <TError = AdminDistributionCsvResult | Unauthorized | NotFound | BadRequest,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCsvCreate>>, TError,{licenseId: string;data: AdminDistributionCsvRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCsvCreate>>, TError,{licenseId: string;data: AdminDistributionCsvRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCsvCreate>>, {licenseId: string;data: AdminDistributionCsvRequest}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  adminLicensesDetailDistributionItemsCsvCreate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailDistributionItemsCsvCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCsvCreate>>>
    export type AdminLicensesDetailDistributionItemsCsvCreateMutationBody = AdminDistributionCsvRequest
    export type AdminLicensesDetailDistributionItemsCsvCreateMutationError = AdminDistributionCsvResult | Unauthorized | NotFound | BadRequest

    export const useAdminLicensesDetailDistributionItemsCsvCreate = <TError = AdminDistributionCsvResult | Unauthorized | NotFound | BadRequest,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCsvCreate>>, TError,{licenseId: string;data: AdminDistributionCsvRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsCsvCreate>>,
        TError,
        {licenseId: string;data: AdminDistributionCsvRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailDistributionItemsCsvCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 期限切れの配布物を消すView

POST: この開催回の配布物を、終了日時から保管期間を過ぎていれば物理削除する。
期限前なら何も消さない（deleted=0）。全開催回をまとめて消すときは
管理コマンド `manage.py purge_distribution_items` を使う。
鍵が無くても動く。
 */
export const adminLicensesDetailDistributionItemsPurgeExpiredCreate = (
    licenseId: string,
 ) => {
      
      
      return orvalAxiosAdapter<AdminDistributionPurge>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/distribution-items/purge-expired/`, method: 'POST'
    },
      );
    }
  


export const getAdminLicensesDetailDistributionItemsPurgeExpiredCreateMutationOptions = <TError = Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsPurgeExpiredCreate>>, TError,{licenseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsPurgeExpiredCreate>>, TError,{licenseId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsPurgeExpiredCreate>>, {licenseId: string}> = (props) => {
          const {licenseId} = props ?? {};

          return  adminLicensesDetailDistributionItemsPurgeExpiredCreate(licenseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailDistributionItemsPurgeExpiredCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsPurgeExpiredCreate>>>
    
    export type AdminLicensesDetailDistributionItemsPurgeExpiredCreateMutationError = Unauthorized | NotFound

    export const useAdminLicensesDetailDistributionItemsPurgeExpiredCreate = <TError = Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsPurgeExpiredCreate>>, TError,{licenseId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailDistributionItemsPurgeExpiredCreate>>,
        TError,
        {licenseId: string},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailDistributionItemsPurgeExpiredCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 開催回の参加権限（GrantedLicense）を組織メンバー全員に付け直すためのView

POST: 対象ライセンスの組織に所属する全 OrganizationUser へ GrantedLicense を
付与する。既に付与済みのメンバーはスキップするため、何度実行しても結果は同じ。

ライセンス作成後に追加されたメンバーには権限が付かないため、
従来は is_valid を OFF→ON し直す以外に付与し直す手段が無かった。
その操作は OFF の時点で全 GrantedLicense を物理削除するので、
ON が失敗すると全員が一斉にアクセスを失う。
 */
export const adminLicensesDetailGrantsCreate = (
    licenseId: string,
 ) => {
      
      
      return orvalAxiosAdapter<AdminLicenseGrantSyncResponse>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/grants/`, method: 'POST'
    },
      );
    }
  


export const getAdminLicensesDetailGrantsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailGrantsCreate>>, TError,{licenseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailGrantsCreate>>, TError,{licenseId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailGrantsCreate>>, {licenseId: string}> = (props) => {
          const {licenseId} = props ?? {};

          return  adminLicensesDetailGrantsCreate(licenseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailGrantsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailGrantsCreate>>>
    
    export type AdminLicensesDetailGrantsCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminLicensesDetailGrantsCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailGrantsCreate>>, TError,{licenseId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailGrantsCreate>>,
        TError,
        {licenseId: string},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailGrantsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 開催回の参加者と、その種類（参加者・運営・オブザーバー）を管理するView

GET: 参加者（参加権限を持つ人・投稿した人・種類が付いている人）と種類を返す。

PATCH: 指定した人の種類をまとめて変える（1人なら1件だけ送る）。

スコアの対象に入れるかは開催回の設定（include_staff_in_scores /
include_observers_in_scores）で決める。設定は開催回の PATCH で変える。
 */
export const adminLicensesDetailParticipantsRetrieve = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminLicenseParticipants>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/participants/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminLicensesDetailParticipantsRetrieveQueryKey = (licenseId: string,) => {
    return [`/api/v1/admin/licenses_detail/${licenseId}/participants/`] as const;
    }

    
export const getAdminLicensesDetailParticipantsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError = Unauthorized | NotFound>(licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLicensesDetailParticipantsRetrieveQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>> = ({ signal }) => adminLicensesDetailParticipantsRetrieve(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminLicensesDetailParticipantsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>>
export type AdminLicensesDetailParticipantsRetrieveQueryError = Unauthorized | NotFound


export function useAdminLicensesDetailParticipantsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailParticipantsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailParticipantsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminLicensesDetailParticipantsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminLicensesDetailParticipantsRetrieveQueryOptions(licenseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 開催回の参加者と、その種類（参加者・運営・オブザーバー）を管理するView

GET: 参加者（参加権限を持つ人・投稿した人・種類が付いている人）と種類を返す。

PATCH: 指定した人の種類をまとめて変える（1人なら1件だけ送る）。

スコアの対象に入れるかは開催回の設定（include_staff_in_scores /
include_observers_in_scores）で決める。設定は開催回の PATCH で変える。
 */
export const adminLicensesDetailParticipantsPartialUpdate = (
    licenseId: string,
    patchedAdminLicenseParticipantsKindRequest: PatchedAdminLicenseParticipantsKindRequest,
 ) => {
      
      
      return orvalAxiosAdapter<AdminLicenseParticipants>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/participants/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminLicenseParticipantsKindRequest
    },
      );
    }
  


export const getAdminLicensesDetailParticipantsPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsPartialUpdate>>, TError,{licenseId: string;data: PatchedAdminLicenseParticipantsKindRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsPartialUpdate>>, TError,{licenseId: string;data: PatchedAdminLicenseParticipantsKindRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailParticipantsPartialUpdate>>, {licenseId: string;data: PatchedAdminLicenseParticipantsKindRequest}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  adminLicensesDetailParticipantsPartialUpdate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailParticipantsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailParticipantsPartialUpdate>>>
    export type AdminLicensesDetailParticipantsPartialUpdateMutationBody = PatchedAdminLicenseParticipantsKindRequest
    export type AdminLicensesDetailParticipantsPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminLicensesDetailParticipantsPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailParticipantsPartialUpdate>>, TError,{licenseId: string;data: PatchedAdminLicenseParticipantsKindRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailParticipantsPartialUpdate>>,
        TError,
        {licenseId: string;data: PatchedAdminLicenseParticipantsKindRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailParticipantsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 開催回のチーム分けを管理するView

GET: チームとメンバー、割り当て候補の参加者（参加権限を持つユーザー）を返す。

PUT: チーム分けをまるごと置き換える。

当日の出席を見て組み替えることが多いため、画面で編集した結果を一度に保存する
形にしている。送られなかったチームは削除する。チームの順位は保存していないので
（表示のたびに今のメンバーから計算する）、組み替えはすぐリーダーボードに効く。
 */
export const adminLicensesDetailTeamsRetrieve = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminLicenseTeams>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/teams/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminLicensesDetailTeamsRetrieveQueryKey = (licenseId: string,) => {
    return [`/api/v1/admin/licenses_detail/${licenseId}/teams/`] as const;
    }

    
export const getAdminLicensesDetailTeamsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError = Unauthorized | NotFound>(licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLicensesDetailTeamsRetrieveQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>> = ({ signal }) => adminLicensesDetailTeamsRetrieve(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminLicensesDetailTeamsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>>
export type AdminLicensesDetailTeamsRetrieveQueryError = Unauthorized | NotFound


export function useAdminLicensesDetailTeamsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailTeamsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminLicensesDetailTeamsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminLicensesDetailTeamsRetrieve<TData = Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminLicensesDetailTeamsRetrieveQueryOptions(licenseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 開催回のチーム分けを管理するView

GET: チームとメンバー、割り当て候補の参加者（参加権限を持つユーザー）を返す。

PUT: チーム分けをまるごと置き換える。

当日の出席を見て組み替えることが多いため、画面で編集した結果を一度に保存する
形にしている。送られなかったチームは削除する。チームの順位は保存していないので
（表示のたびに今のメンバーから計算する）、組み替えはすぐリーダーボードに効く。
 */
export const adminLicensesDetailTeamsUpdate = (
    licenseId: string,
    adminLicenseTeamsRequest: AdminLicenseTeamsRequest,
 ) => {
      
      
      return orvalAxiosAdapter<AdminLicenseTeams>(
      {url: `/api/v1/admin/licenses_detail/${licenseId}/teams/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminLicenseTeamsRequest
    },
      );
    }
  


export const getAdminLicensesDetailTeamsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsUpdate>>, TError,{licenseId: string;data: AdminLicenseTeamsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsUpdate>>, TError,{licenseId: string;data: AdminLicenseTeamsRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLicensesDetailTeamsUpdate>>, {licenseId: string;data: AdminLicenseTeamsRequest}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  adminLicensesDetailTeamsUpdate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminLicensesDetailTeamsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminLicensesDetailTeamsUpdate>>>
    export type AdminLicensesDetailTeamsUpdateMutationBody = AdminLicenseTeamsRequest
    export type AdminLicensesDetailTeamsUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminLicensesDetailTeamsUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLicensesDetailTeamsUpdate>>, TError,{licenseId: string;data: AdminLicenseTeamsRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminLicensesDetailTeamsUpdate>>,
        TError,
        {licenseId: string;data: AdminLicenseTeamsRequest},
        TContext
      > => {

      const mutationOptions = getAdminLicensesDetailTeamsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が職種を作成するためのView

POST: 職種を作成する。

GET: 職種一覧を取得

PUT: 職種情報を更新する。

PATCH: 職種情報を部分的に更新する。
 */
export const adminOccupationsList = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminOccupation[]>(
      {url: `/api/v1/admin/occupations/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOccupationsListQueryKey = () => {
    return [`/api/v1/admin/occupations/`] as const;
    }

    
export const getAdminOccupationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminOccupationsList>>, TError = Unauthorized | NotFound>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOccupationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOccupationsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOccupationsList>>> = ({ signal }) => adminOccupationsList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOccupationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminOccupationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOccupationsList>>>
export type AdminOccupationsListQueryError = Unauthorized | NotFound


export function useAdminOccupationsList<TData = Awaited<ReturnType<typeof adminOccupationsList>>, TError = Unauthorized | NotFound>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOccupationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOccupationsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOccupationsList<TData = Awaited<ReturnType<typeof adminOccupationsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOccupationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOccupationsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOccupationsList<TData = Awaited<ReturnType<typeof adminOccupationsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOccupationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminOccupationsList<TData = Awaited<ReturnType<typeof adminOccupationsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOccupationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminOccupationsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が職種を作成するためのView

POST: 職種を作成する。

GET: 職種一覧を取得

PUT: 職種情報を更新する。

PATCH: 職種情報を部分的に更新する。
 */
export const adminOccupationsCreate = (
    adminOccupationRequest: AdminOccupationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminOccupationRequest.name)

      return orvalAxiosAdapter<AdminOccupation>(
      {url: `/api/v1/admin/occupations/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminOccupationsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsCreate>>, TError,{data: AdminOccupationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsCreate>>, TError,{data: AdminOccupationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOccupationsCreate>>, {data: AdminOccupationRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminOccupationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOccupationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminOccupationsCreate>>>
    export type AdminOccupationsCreateMutationBody = AdminOccupationRequest
    export type AdminOccupationsCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminOccupationsCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsCreate>>, TError,{data: AdminOccupationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminOccupationsCreate>>,
        TError,
        {data: AdminOccupationRequest},
        TContext
      > => {

      const mutationOptions = getAdminOccupationsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が職種を作成するためのView

POST: 職種を作成する。

GET: 職種一覧を取得

PUT: 職種情報を更新する。

PATCH: 職種情報を部分的に更新する。
 */
export const adminOccupationsUpdate = (
    adminOccupationRequest: AdminOccupationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminOccupationRequest.name)

      return orvalAxiosAdapter<AdminOccupation>(
      {url: `/api/v1/admin/occupations/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminOccupationsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsUpdate>>, TError,{data: AdminOccupationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsUpdate>>, TError,{data: AdminOccupationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOccupationsUpdate>>, {data: AdminOccupationRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminOccupationsUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOccupationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminOccupationsUpdate>>>
    export type AdminOccupationsUpdateMutationBody = AdminOccupationRequest
    export type AdminOccupationsUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminOccupationsUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsUpdate>>, TError,{data: AdminOccupationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminOccupationsUpdate>>,
        TError,
        {data: AdminOccupationRequest},
        TContext
      > => {

      const mutationOptions = getAdminOccupationsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が職種を作成するためのView

POST: 職種を作成する。

GET: 職種一覧を取得

PUT: 職種情報を更新する。

PATCH: 職種情報を部分的に更新する。
 */
export const adminOccupationsPartialUpdate = (
    patchedAdminOccupationRequest: PatchedAdminOccupationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminOccupationRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedAdminOccupationRequest.name)
 }

      return orvalAxiosAdapter<AdminOccupation>(
      {url: `/api/v1/admin/occupations/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminOccupationsPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsPartialUpdate>>, TError,{data: PatchedAdminOccupationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsPartialUpdate>>, TError,{data: PatchedAdminOccupationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOccupationsPartialUpdate>>, {data: PatchedAdminOccupationRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminOccupationsPartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOccupationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminOccupationsPartialUpdate>>>
    export type AdminOccupationsPartialUpdateMutationBody = PatchedAdminOccupationRequest
    export type AdminOccupationsPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminOccupationsPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOccupationsPartialUpdate>>, TError,{data: PatchedAdminOccupationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminOccupationsPartialUpdate>>,
        TError,
        {data: PatchedAdminOccupationRequest},
        TContext
      > => {

      const mutationOptions = getAdminOccupationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が企業ユーザー一覧を取得するためのView

GET: 企業ユーザー一覧を取得
 */
export const adminOrganizationUsersList = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminOrganizationUser[]>(
      {url: `/api/v1/admin/organization_users/${organizationId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationUsersListQueryKey = (organizationId: string,) => {
    return [`/api/v1/admin/organization_users/${organizationId}/`] as const;
    }

    
export const getAdminOrganizationUsersListQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError = Unauthorized | NotFound>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationUsersListQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationUsersList>>> = ({ signal }) => adminOrganizationUsersList(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminOrganizationUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUsersList>>>
export type AdminOrganizationUsersListQueryError = Unauthorized | NotFound


export function useAdminOrganizationUsersList<TData = Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUsersList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationUsersList<TData = Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUsersList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationUsersList<TData = Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminOrganizationUsersList<TData = Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError = Unauthorized | NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUsersList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminOrganizationUsersListQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が企業を作成するためのView

POST: 企業を作成する。

GET: 企業一覧を取得

PUT: 企業情報を更新する。

PATCH: 企業情報を部分的に更新する。
 */
export const adminOrganizationsList = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminOrganization[]>(
      {url: `/api/v1/admin/organizations/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationsListQueryKey = () => {
    return [`/api/v1/admin/organizations/`] as const;
    }

    
export const getAdminOrganizationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationsList>>, TError = Unauthorized | NotFound>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationsList>>> = ({ signal }) => adminOrganizationsList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminOrganizationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationsList>>>
export type AdminOrganizationsListQueryError = Unauthorized | NotFound


export function useAdminOrganizationsList<TData = Awaited<ReturnType<typeof adminOrganizationsList>>, TError = Unauthorized | NotFound>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationsList<TData = Awaited<ReturnType<typeof adminOrganizationsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationsList<TData = Awaited<ReturnType<typeof adminOrganizationsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminOrganizationsList<TData = Awaited<ReturnType<typeof adminOrganizationsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminOrganizationsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が企業を作成するためのView

POST: 企業を作成する。

GET: 企業一覧を取得

PUT: 企業情報を更新する。

PATCH: 企業情報を部分的に更新する。
 */
export const adminOrganizationsCreate = (
    adminOrganizationRequest: AdminOrganizationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminOrganizationRequest.name)

      return orvalAxiosAdapter<AdminOrganization>(
      {url: `/api/v1/admin/organizations/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminOrganizationsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsCreate>>, TError,{data: AdminOrganizationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsCreate>>, TError,{data: AdminOrganizationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationsCreate>>, {data: AdminOrganizationRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminOrganizationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationsCreate>>>
    export type AdminOrganizationsCreateMutationBody = AdminOrganizationRequest
    export type AdminOrganizationsCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminOrganizationsCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsCreate>>, TError,{data: AdminOrganizationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationsCreate>>,
        TError,
        {data: AdminOrganizationRequest},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が企業の詳細を取得するView

GET: 企業詳細を取得
 */
export const adminOrganizationsRetrieve = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminOrganization>(
      {url: `/api/v1/admin/organizations/${organizationId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationsRetrieveQueryKey = (organizationId: string,) => {
    return [`/api/v1/admin/organizations/${organizationId}/`] as const;
    }

    
export const getAdminOrganizationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError = NotFound>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationsRetrieveQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>> = ({ signal }) => adminOrganizationsRetrieve(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminOrganizationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>>
export type AdminOrganizationsRetrieveQueryError = NotFound


export function useAdminOrganizationsRetrieve<TData = Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError = NotFound>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationsRetrieve<TData = Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError = NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminOrganizationsRetrieve<TData = Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError = NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminOrganizationsRetrieve<TData = Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError = NotFound>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminOrganizationsRetrieveQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が企業の詳細を取得するView

GET: 企業詳細を取得
 */
export const adminOrganizationsUpdate = (
    organizationId: string,
    adminOrganizationRequest: AdminOrganizationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminOrganizationRequest.name)

      return orvalAxiosAdapter<AdminOrganization>(
      {url: `/api/v1/admin/organizations/${organizationId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminOrganizationsUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsUpdate>>, TError,{organizationId: string;data: AdminOrganizationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsUpdate>>, TError,{organizationId: string;data: AdminOrganizationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationsUpdate>>, {organizationId: string;data: AdminOrganizationRequest}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminOrganizationsUpdate(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationsUpdate>>>
    export type AdminOrganizationsUpdateMutationBody = AdminOrganizationRequest
    export type AdminOrganizationsUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminOrganizationsUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsUpdate>>, TError,{organizationId: string;data: AdminOrganizationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationsUpdate>>,
        TError,
        {organizationId: string;data: AdminOrganizationRequest},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者が企業の詳細を取得するView

GET: 企業詳細を取得
 */
export const adminOrganizationsPartialUpdate = (
    organizationId: string,
    patchedAdminOrganizationRequest: PatchedAdminOrganizationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedAdminOrganizationRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedAdminOrganizationRequest.name)
 }

      return orvalAxiosAdapter<AdminOrganization>(
      {url: `/api/v1/admin/organizations/${organizationId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminOrganizationsPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsPartialUpdate>>, TError,{organizationId: string;data: PatchedAdminOrganizationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsPartialUpdate>>, TError,{organizationId: string;data: PatchedAdminOrganizationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationsPartialUpdate>>, {organizationId: string;data: PatchedAdminOrganizationRequest}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminOrganizationsPartialUpdate(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationsPartialUpdate>>>
    export type AdminOrganizationsPartialUpdateMutationBody = PatchedAdminOrganizationRequest
    export type AdminOrganizationsPartialUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminOrganizationsPartialUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationsPartialUpdate>>, TError,{organizationId: string;data: PatchedAdminOrganizationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationsPartialUpdate>>,
        TError,
        {organizationId: string;data: PatchedAdminOrganizationRequest},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * ユーザが投稿した結果ファイル（results.json）を取得するためのViewクラス

GET: ダウンロードファイルを取得
 */
export const adminSubmissionFileRetrieve = (
    submissionId: string,
    fileType: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<Blob>(
      {url: `/api/v1/admin/submission_file/${submissionId}/${fileType}/`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getAdminSubmissionFileRetrieveQueryKey = (submissionId: string,
    fileType: string,) => {
    return [`/api/v1/admin/submission_file/${submissionId}/${fileType}/`] as const;
    }

    
export const getAdminSubmissionFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError = Unauthorized | NotFound>(submissionId: string,
    fileType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSubmissionFileRetrieveQueryKey(submissionId,fileType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>> = ({ signal }) => adminSubmissionFileRetrieve(submissionId,fileType, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(submissionId && fileType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminSubmissionFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>>
export type AdminSubmissionFileRetrieveQueryError = Unauthorized | NotFound


export function useAdminSubmissionFileRetrieve<TData = Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string,
    fileType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminSubmissionFileRetrieve<TData = Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string,
    fileType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminSubmissionFileRetrieve<TData = Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string,
    fileType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminSubmissionFileRetrieve<TData = Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string,
    fileType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionFileRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminSubmissionFileRetrieveQueryOptions(submissionId,fileType,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者が提出コードを取得するためのView

GET: 提出コード一覧を取得
 */
export const adminSubmissionsList = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminSubmission[]>(
      {url: `/api/v1/admin/submissions/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminSubmissionsListQueryKey = () => {
    return [`/api/v1/admin/submissions/`] as const;
    }

    
export const getAdminSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof adminSubmissionsList>>, TError = Unauthorized | NotFound>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSubmissionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSubmissionsList>>> = ({ signal }) => adminSubmissionsList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminSubmissionsList>>>
export type AdminSubmissionsListQueryError = Unauthorized | NotFound


export function useAdminSubmissionsList<TData = Awaited<ReturnType<typeof adminSubmissionsList>>, TError = Unauthorized | NotFound>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSubmissionsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminSubmissionsList<TData = Awaited<ReturnType<typeof adminSubmissionsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSubmissionsList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminSubmissionsList<TData = Awaited<ReturnType<typeof adminSubmissionsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminSubmissionsList<TData = Awaited<ReturnType<typeof adminSubmissionsList>>, TError = Unauthorized | NotFound>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSubmissionsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminSubmissionsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者がユーザーが取得している資格を一覧で取得するためのView

GET: 資格一覧を取得
 */
export const adminUserGrantedLicenseList = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminGrantedLicense[]>(
      {url: `/api/v1/admin/user_granted_license/${userId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminUserGrantedLicenseListQueryKey = (userId: string,) => {
    return [`/api/v1/admin/user_granted_license/${userId}/`] as const;
    }

    
export const getAdminUserGrantedLicenseListQueryOptions = <TData = Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError = Unauthorized | NotFound>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminUserGrantedLicenseListQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>> = ({ signal }) => adminUserGrantedLicenseList(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminUserGrantedLicenseListQueryResult = NonNullable<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>>
export type AdminUserGrantedLicenseListQueryError = Unauthorized | NotFound


export function useAdminUserGrantedLicenseList<TData = Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError = Unauthorized | NotFound>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUserGrantedLicenseList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminUserGrantedLicenseList<TData = Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError = Unauthorized | NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUserGrantedLicenseList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminUserGrantedLicenseList<TData = Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError = Unauthorized | NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminUserGrantedLicenseList<TData = Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError = Unauthorized | NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminUserGrantedLicenseListQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者がユーザーが取得している資格を削除するためのView

DELETE: 資格を削除
 */
export const adminUserGrantedLicenseDetailDestroy = (
    licenseId: string,
 ) => {
      
      
      return orvalAxiosAdapter<void>(
      {url: `/api/v1/admin/user_granted_license_detail/${licenseId}/`, method: 'DELETE'
    },
      );
    }
  


export const getAdminUserGrantedLicenseDetailDestroyMutationOptions = <TError = Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseDetailDestroy>>, TError,{licenseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseDetailDestroy>>, TError,{licenseId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUserGrantedLicenseDetailDestroy>>, {licenseId: string}> = (props) => {
          const {licenseId} = props ?? {};

          return  adminUserGrantedLicenseDetailDestroy(licenseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUserGrantedLicenseDetailDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminUserGrantedLicenseDetailDestroy>>>
    
    export type AdminUserGrantedLicenseDetailDestroyMutationError = Unauthorized | NotFound

    export const useAdminUserGrantedLicenseDetailDestroy = <TError = Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserGrantedLicenseDetailDestroy>>, TError,{licenseId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUserGrantedLicenseDetailDestroy>>,
        TError,
        {licenseId: string},
        TContext
      > => {

      const mutationOptions = getAdminUserGrantedLicenseDetailDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者がユーザーを作成するためのView

POST: ユーザーを作成する。この段階ではまだFirebase Authenticationへの登録は行われていない。

GET: ユーザー一覧を取得
 */
export const adminUsersList = (
    params?: AdminUsersListParams,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminUser[]>(
      {url: `/api/v1/admin/users/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminUsersListQueryKey = (params?: AdminUsersListParams,) => {
    return [`/api/v1/admin/users/`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminUsersListQueryOptions = <TData = Awaited<ReturnType<typeof adminUsersList>>, TError = Unauthorized>(params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminUsersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsersList>>> = ({ signal }) => adminUsersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminUsersList>>>
export type AdminUsersListQueryError = Unauthorized


export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = Unauthorized>(
 params: undefined |  AdminUsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = Unauthorized>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersList>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = Unauthorized>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminUsersList<TData = Awaited<ReturnType<typeof adminUsersList>>, TError = Unauthorized>(
 params?: AdminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者がユーザーを作成するためのView

POST: ユーザーを作成する。この段階ではまだFirebase Authenticationへの登録は行われていない。

GET: ユーザー一覧を取得
 */
export const adminUsersCreate = (
    adminUserRequestMultiOrganizations: AdminUserRequestMultiOrganizations,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminUserRequestMultiOrganizations.name)
formUrlEncoded.append('email', adminUserRequestMultiOrganizations.email)
if(adminUserRequestMultiOrganizations.organizations !== undefined && adminUserRequestMultiOrganizations.organizations !== null) {
 adminUserRequestMultiOrganizations.organizations.forEach(value => formUrlEncoded.append('organizations', JSON.stringify(value)));
 }

      return orvalAxiosAdapter<AdminUser>(
      {url: `/api/v1/admin/users/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminUsersCreateMutationOptions = <TError = BadRequest | Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersCreate>>, TError,{data: AdminUserRequestMultiOrganizations}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersCreate>>, TError,{data: AdminUserRequestMultiOrganizations}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersCreate>>, {data: AdminUserRequestMultiOrganizations}> = (props) => {
          const {data} = props ?? {};

          return  adminUsersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersCreate>>>
    export type AdminUsersCreateMutationBody = AdminUserRequestMultiOrganizations
    export type AdminUsersCreateMutationError = BadRequest | Unauthorized

    export const useAdminUsersCreate = <TError = BadRequest | Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersCreate>>, TError,{data: AdminUserRequestMultiOrganizations}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersCreate>>,
        TError,
        {data: AdminUserRequestMultiOrganizations},
        TContext
      > => {

      const mutationOptions = getAdminUsersCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者があるユーザーに対する操作をするためのView

Delete: ユーザーを作成する。論理削除でなくレコードごと削除する。

GET: ユーザー詳細を取得

PUT: ユーザー情報を更新する
 */
export const adminUsersRetrieve = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<AdminUser>(
      {url: `/api/v1/admin/users/${userId}/`, method: 'GET', signal
    },
      );
    }
  

export const getAdminUsersRetrieveQueryKey = (userId: string,) => {
    return [`/api/v1/admin/users/${userId}/`] as const;
    }

    
export const getAdminUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminUsersRetrieve>>, TError = NotFound>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminUsersRetrieveQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsersRetrieve>>> = ({ signal }) => adminUsersRetrieve(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUsersRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminUsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminUsersRetrieve>>>
export type AdminUsersRetrieveQueryError = NotFound


export function useAdminUsersRetrieve<TData = Awaited<ReturnType<typeof adminUsersRetrieve>>, TError = NotFound>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminUsersRetrieve<TData = Awaited<ReturnType<typeof adminUsersRetrieve>>, TError = NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAdminUsersRetrieve<TData = Awaited<ReturnType<typeof adminUsersRetrieve>>, TError = NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAdminUsersRetrieve<TData = Awaited<ReturnType<typeof adminUsersRetrieve>>, TError = NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsersRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminUsersRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 管理者があるユーザーに対する操作をするためのView

Delete: ユーザーを作成する。論理削除でなくレコードごと削除する。

GET: ユーザー詳細を取得

PUT: ユーザー情報を更新する
 */
export const adminUsersUpdate = (
    userId: string,
    adminUserRequestMultiOrganizations: AdminUserRequestMultiOrganizations,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', adminUserRequestMultiOrganizations.name)
formUrlEncoded.append('email', adminUserRequestMultiOrganizations.email)
if(adminUserRequestMultiOrganizations.organizations !== undefined && adminUserRequestMultiOrganizations.organizations !== null) {
 adminUserRequestMultiOrganizations.organizations.forEach(value => formUrlEncoded.append('organizations', JSON.stringify(value)));
 }

      return orvalAxiosAdapter<AdminUser>(
      {url: `/api/v1/admin/users/${userId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminUsersUpdateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersUpdate>>, TError,{userId: string;data: AdminUserRequestMultiOrganizations}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersUpdate>>, TError,{userId: string;data: AdminUserRequestMultiOrganizations}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersUpdate>>, {userId: string;data: AdminUserRequestMultiOrganizations}> = (props) => {
          const {userId,data} = props ?? {};

          return  adminUsersUpdate(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersUpdate>>>
    export type AdminUsersUpdateMutationBody = AdminUserRequestMultiOrganizations
    export type AdminUsersUpdateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminUsersUpdate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersUpdate>>, TError,{userId: string;data: AdminUserRequestMultiOrganizations}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersUpdate>>,
        TError,
        {userId: string;data: AdminUserRequestMultiOrganizations},
        TContext
      > => {

      const mutationOptions = getAdminUsersUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 管理者があるユーザーに対する操作をするためのView

Delete: ユーザーを作成する。論理削除でなくレコードごと削除する。

GET: ユーザー詳細を取得

PUT: ユーザー情報を更新する
 */
export const adminUsersDestroy = (
    userId: string,
 ) => {
      
      
      return orvalAxiosAdapter<void>(
      {url: `/api/v1/admin/users/${userId}/`, method: 'DELETE'
    },
      );
    }
  


export const getAdminUsersDestroyMutationOptions = <TError = Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersDestroy>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersDestroy>>, TError,{userId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersDestroy>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  adminUsersDestroy(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersDestroy>>>
    
    export type AdminUsersDestroyMutationError = Unauthorized

    export const useAdminUsersDestroy = <TError = Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersDestroy>>, TError,{userId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersDestroy>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getAdminUsersDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * あるユーザーの組織に対する操作を行うView

POST: 対象のユーザーをオーナーとする組織の作成
 */
export const adminUsersOrganizationsCreate = (
    userId: string,
    organizationRequest: OrganizationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', organizationRequest.name)

      return orvalAxiosAdapter<Organization>(
      {url: `/api/v1/admin/users/${userId}/organizations/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getAdminUsersOrganizationsCreateMutationOptions = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersOrganizationsCreate>>, TError,{userId: string;data: OrganizationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersOrganizationsCreate>>, TError,{userId: string;data: OrganizationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersOrganizationsCreate>>, {userId: string;data: OrganizationRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  adminUsersOrganizationsCreate(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersOrganizationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersOrganizationsCreate>>>
    export type AdminUsersOrganizationsCreateMutationBody = OrganizationRequest
    export type AdminUsersOrganizationsCreateMutationError = BadRequest | Unauthorized | NotFound

    export const useAdminUsersOrganizationsCreate = <TError = BadRequest | Unauthorized | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersOrganizationsCreate>>, TError,{userId: string;data: OrganizationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersOrganizationsCreate>>,
        TError,
        {userId: string;data: OrganizationRequest},
        TContext
      > => {

      const mutationOptions = getAdminUsersOrganizationsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * ユーザがコンペの添付ファイルを取得するためのViewクラス

GET: ダウンロードファイルを取得
 */
export const attachmentsRetrieve = (
    attachmentId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<Blob>(
      {url: `/api/v1/attachments/${attachmentId}/`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getAttachmentsRetrieveQueryKey = (attachmentId: string,) => {
    return [`/api/v1/attachments/${attachmentId}/`] as const;
    }

    
export const getAttachmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = Unauthorized | NotFound>(attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAttachmentsRetrieveQueryKey(attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof attachmentsRetrieve>>> = ({ signal }) => attachmentsRetrieve(attachmentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AttachmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof attachmentsRetrieve>>>
export type AttachmentsRetrieveQueryError = Unauthorized | NotFound


export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAttachmentsRetrieveQueryOptions(attachmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Competition Detail View

GET: Get competition information based on the license
 */
export const competitionsRetrieve = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<LicensedCompetitionDetail>(
      {url: `/api/v1/competitions/${licenseId}/`, method: 'GET', signal
    },
      );
    }
  

export const getCompetitionsRetrieveQueryKey = (licenseId: string,) => {
    return [`/api/v1/competitions/${licenseId}/`] as const;
    }

    
export const getCompetitionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof competitionsRetrieve>>, TError = Unauthorized | NotFound>(licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompetitionsRetrieveQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof competitionsRetrieve>>> = ({ signal }) => competitionsRetrieve(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof competitionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompetitionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof competitionsRetrieve>>>
export type CompetitionsRetrieveQueryError = Unauthorized | NotFound


export function useCompetitionsRetrieve<TData = Awaited<ReturnType<typeof competitionsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitionsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCompetitionsRetrieve<TData = Awaited<ReturnType<typeof competitionsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitionsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCompetitionsRetrieve<TData = Awaited<ReturnType<typeof competitionsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useCompetitionsRetrieve<TData = Awaited<ReturnType<typeof competitionsRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCompetitionsRetrieveQueryOptions(licenseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 自分に配られた配布物（API キー・トークンなど）のView

GET: 本人の参加者単位の分と、本人のチームの分だけを返す。

- 開催の開始日時より前は、項目名だけで値は null。

- 終了から保管期間を過ぎた開催回は、何も返さない。

- 値を返したときは、閲覧の記録を残す。

開催回の詳細（大きな応答）には入れず、別の窓口にしている。
 */
export const competitionsDistributionItemsRetrieve = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<DistributionItemList>(
      {url: `/api/v1/competitions/${licenseId}/distribution-items/`, method: 'GET', signal
    },
      );
    }
  

export const getCompetitionsDistributionItemsRetrieveQueryKey = (licenseId: string,) => {
    return [`/api/v1/competitions/${licenseId}/distribution-items/`] as const;
    }

    
export const getCompetitionsDistributionItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompetitionsDistributionItemsRetrieveQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>> = ({ signal }) => competitionsDistributionItemsRetrieve(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompetitionsDistributionItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>>
export type CompetitionsDistributionItemsRetrieveQueryError = Unauthorized | NotFound | BadRequest


export function useCompetitionsDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCompetitionsDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCompetitionsDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useCompetitionsDistributionItemsRetrieve<TData = Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError = Unauthorized | NotFound | BadRequest>(
 licenseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsDistributionItemsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCompetitionsDistributionItemsRetrieveQueryOptions(licenseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ユーザがコンペの画像を取得するためのViewクラス

GET: 画像を取得
 */
export const competitionsImagesRetrieve = (
    licenseId: string,
    imageType: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<Blob>(
      {url: `/api/v1/competitions/${licenseId}/images/${imageType}`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getCompetitionsImagesRetrieveQueryKey = (licenseId: string,
    imageType: string,) => {
    return [`/api/v1/competitions/${licenseId}/images/${imageType}`] as const;
    }

    
export const getCompetitionsImagesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError = Unauthorized | NotFound>(licenseId: string,
    imageType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompetitionsImagesRetrieveQueryKey(licenseId,imageType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof competitionsImagesRetrieve>>> = ({ signal }) => competitionsImagesRetrieve(licenseId,imageType, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId && imageType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompetitionsImagesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof competitionsImagesRetrieve>>>
export type CompetitionsImagesRetrieveQueryError = Unauthorized | NotFound


export function useCompetitionsImagesRetrieve<TData = Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    imageType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitionsImagesRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCompetitionsImagesRetrieve<TData = Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    imageType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitionsImagesRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCompetitionsImagesRetrieve<TData = Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    imageType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useCompetitionsImagesRetrieve<TData = Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    imageType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof competitionsImagesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCompetitionsImagesRetrieveQueryOptions(licenseId,imageType,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Langflowのフロー定義とPPTXファイルを提出するためのView.
TODO: 仮実装のため、後から処理を変更する必要あり

POST: Langflowのフロー定義(JSON)とPPTXファイル(最大5個)を受け取る

ローカル環境でのcurlコマンド例:
curl -X 'POST'         'http://127.0.0.1:8889/api/v1/competitions/1001/langflow_submissions/'         -H 'accept: application/json'         -H "Content-Type: multipart/form-data"         -H 'Authorization: Bearer <JWT>'         -F "flow_json=@/path/to/flow.json"         -F "pptx_file_1=@/path/to/file1.pptx"         -F "pptx_file_2=@/path/to/file2.pptx"         -F "file_name=my_custom_name"

上記のコマンドのうち、Authorizationヘッダの<JWT>部分はFirebase Authenticationで取得したJWTを指定すること
また、dev環境の動作確認をしたい場合は http://127.0.0.1:8889 部分をdev環境のCloud RunのURLに変更すること
file_nameはオプションパラメータで、指定しない場合はJSONファイル名が使用されます
 */
export const competitionsLangflowSubmissionsCreate = (
    licenseId: string,
    langflowUpload: LangflowUpload,
 ) => {
      
      const formData = new FormData();
if(langflowUpload.pptxFile1 !== undefined && langflowUpload.pptxFile1 !== null) {
 formData.append('pptxFile1', langflowUpload.pptxFile1)
 }
if(langflowUpload.pptxFile2 !== undefined && langflowUpload.pptxFile2 !== null) {
 formData.append('pptxFile2', langflowUpload.pptxFile2)
 }
if(langflowUpload.pptxFile3 !== undefined && langflowUpload.pptxFile3 !== null) {
 formData.append('pptxFile3', langflowUpload.pptxFile3)
 }
if(langflowUpload.pptxFile4 !== undefined && langflowUpload.pptxFile4 !== null) {
 formData.append('pptxFile4', langflowUpload.pptxFile4)
 }
if(langflowUpload.pptxFile5 !== undefined && langflowUpload.pptxFile5 !== null) {
 formData.append('pptxFile5', langflowUpload.pptxFile5)
 }
formData.append('flowJson', langflowUpload.flowJson)
if(langflowUpload.fileName !== undefined) {
 formData.append('fileName', langflowUpload.fileName)
 }

      return orvalAxiosAdapter<LangflowSubmissionLimitResponse | LangflowSubmissionResponse>(
      {url: `/api/v1/competitions/${licenseId}/langflow_submissions/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getCompetitionsLangflowSubmissionsCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsLangflowSubmissionsCreate>>, TError,{licenseId: string;data: LangflowUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof competitionsLangflowSubmissionsCreate>>, TError,{licenseId: string;data: LangflowUpload}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof competitionsLangflowSubmissionsCreate>>, {licenseId: string;data: LangflowUpload}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  competitionsLangflowSubmissionsCreate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompetitionsLangflowSubmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof competitionsLangflowSubmissionsCreate>>>
    export type CompetitionsLangflowSubmissionsCreateMutationBody = LangflowUpload
    export type CompetitionsLangflowSubmissionsCreateMutationError = BadRequest | Unauthorized | Forbidden

    export const useCompetitionsLangflowSubmissionsCreate = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsLangflowSubmissionsCreate>>, TError,{licenseId: string;data: LangflowUpload}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof competitionsLangflowSubmissionsCreate>>,
        TError,
        {licenseId: string;data: LangflowUpload},
        TContext
      > => {

      const mutationOptions = getCompetitionsLangflowSubmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * モデルと推論用のコードをzipファイルにまとめて提出し、
推論の処理をリクエストするためのView.
RAGコンペティション用。inference-runner2を使用

POST: 推論結果を評価関数に送信
 */
export const competitionsModelRagSubmissionsCreate = (
    licenseId: string,
    zIPUpload: ZIPUpload,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('file', zIPUpload.file)

      return orvalAxiosAdapter<ModelRagSubmissionResponse>(
      {url: `/api/v1/competitions/${licenseId}/model-rag-submissions/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getCompetitionsModelRagSubmissionsCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsModelRagSubmissionsCreate>>, TError,{licenseId: string;data: ZIPUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof competitionsModelRagSubmissionsCreate>>, TError,{licenseId: string;data: ZIPUpload}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof competitionsModelRagSubmissionsCreate>>, {licenseId: string;data: ZIPUpload}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  competitionsModelRagSubmissionsCreate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompetitionsModelRagSubmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof competitionsModelRagSubmissionsCreate>>>
    export type CompetitionsModelRagSubmissionsCreateMutationBody = ZIPUpload
    export type CompetitionsModelRagSubmissionsCreateMutationError = BadRequest | Unauthorized | Forbidden

    export const useCompetitionsModelRagSubmissionsCreate = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsModelRagSubmissionsCreate>>, TError,{licenseId: string;data: ZIPUpload}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof competitionsModelRagSubmissionsCreate>>,
        TError,
        {licenseId: string;data: ZIPUpload},
        TContext
      > => {

      const mutationOptions = getCompetitionsModelRagSubmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * モデルと推論用のコードをzipファイルにまとめて提出し、
推論の処理をリクエストするためのView.
TODO: inference_runnerの動作確認のために
必要な箇所のみ実装しているため、修正が必要。APIのテストも用実装

POST: 推論結果を評価関数に送信

ローカル環境でのcurlコマンド例:

curl -X 'POST'         'http://127.0.0.1:8889/api/v1/competitions/1001/model-submissions/'         -H 'accept: application/json'         -H "Content-Type: multipart/form-data"         -H 'Authorization: Bearer <JWT>'         -F "file=@/path/to/model-and-code.zip"

上記のコマンドのうち、Authorizationヘッダの<JWT>部分はFirebase Authenticationで取得したJWTを指定すること

また、dev環境の動作確認をしたい場合は http://127.0.0.1:8889 部分をdev環境のCloud RunのURLに変更すること


cmp-test-data-dev バケットにあらかじめ以下のようなblobが格納されていることを前提としている。

本来はコンペ登録時にテストデータとしてCloud Storageに格納される想定だが、現在は動作確認のため手動で用意している。
- <competition_id>/data

- <competition_id>/ground_truth.csv

<competition_id>/dataフォルダにはコンペティションで使用するテストデータが格納されていること

また、上記 blob のURIのうち <competition_id> はコンペティションID（整数値）に置き換えること


ground_truth.csvファイルは以下のフォーマットを想定
- ID列とtarget列をもつ
- ID列は整数値
- target列は分類タスクの場合は整数値、回帰タスクの場合は浮動小数点数を想定
- このAPIでアップロードされるsubmission.csvは、ground_truth.csvと同じid列を持つ
 */
export const competitionsModelSubmissionsCreate = (
    licenseId: string,
    zIPUpload: ZIPUpload,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('file', zIPUpload.file)

      return orvalAxiosAdapter<ModelSubmissionResponse>(
      {url: `/api/v1/competitions/${licenseId}/model-submissions/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getCompetitionsModelSubmissionsCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsModelSubmissionsCreate>>, TError,{licenseId: string;data: ZIPUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof competitionsModelSubmissionsCreate>>, TError,{licenseId: string;data: ZIPUpload}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof competitionsModelSubmissionsCreate>>, {licenseId: string;data: ZIPUpload}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  competitionsModelSubmissionsCreate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompetitionsModelSubmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof competitionsModelSubmissionsCreate>>>
    export type CompetitionsModelSubmissionsCreateMutationBody = ZIPUpload
    export type CompetitionsModelSubmissionsCreateMutationError = BadRequest | Unauthorized | Forbidden

    export const useCompetitionsModelSubmissionsCreate = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsModelSubmissionsCreate>>, TError,{licenseId: string;data: ZIPUpload}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof competitionsModelSubmissionsCreate>>,
        TError,
        {licenseId: string;data: ZIPUpload},
        TContext
      > => {

      const mutationOptions = getCompetitionsModelSubmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 推論結果を提出して評価関数に送信するためのView.
TODO: evaluation_metrics_calculatorの動作確認のために
必要な箇所のみ実装しているため、修正が必要。APIのテストも用実装

POST: 推論結果を評価関数に送信

ローカル環境でのcurlコマンド例:

curl -X 'POST'         'http://127.0.0.1:8889/api/v1/competitions/1001/submissions/'         -H 'accept: application/json'         -H "Content-Type: multipart/form-data"         -H 'Authorization: Bearer <JWT>'         -F "file=@/path/to/submission.csv"

上記のコマンドのうち、Authorizationヘッダの<JWT>部分はFirebase Authenticationで取得したJWTを指定すること

また、dev環境の動作確認をしたい場合は http://127.0.0.1:8889 部分をdev環境のCloud RunのURLに変更すること


cmp-test-data-dev バケットにあらかじめ以下のようなblobが格納されていることを前提としている。

本来はコンペ登録時にテストデータとしてCloud Storageに格納される想定だが、現在は動作確認のため手動で用意している。
- <competition_id>/ground_truth.csv

上記 blob のURIのうち <competition_id> はコンペティションID（整数値）に置き換えること


csvファイルは以下のフォーマットを想定
- ID列とtarget列をもつ
- ID列は整数値
- target列は分類タスクの場合は整数値、回帰タスクの場合は浮動小数点数を想定
- このAPIでアップロードされるsubmission.csvは、ground_truth.csvと同じid列を持つ
 */
export const competitionsSubmissionsCreate = (
    licenseId: string,
    cSVUpload: CSVUpload,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('file', cSVUpload.file)
if(cSVUpload.fileName !== undefined) {
 formUrlEncoded.append('fileName', cSVUpload.fileName)
 }

      return orvalAxiosAdapter<ResultSubmissionResponse | NoContentResponse>(
      {url: `/api/v1/competitions/${licenseId}/submissions/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getCompetitionsSubmissionsCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsSubmissionsCreate>>, TError,{licenseId: string;data: CSVUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof competitionsSubmissionsCreate>>, TError,{licenseId: string;data: CSVUpload}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof competitionsSubmissionsCreate>>, {licenseId: string;data: CSVUpload}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  competitionsSubmissionsCreate(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompetitionsSubmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof competitionsSubmissionsCreate>>>
    export type CompetitionsSubmissionsCreateMutationBody = CSVUpload
    export type CompetitionsSubmissionsCreateMutationError = BadRequest | Unauthorized | Forbidden

    export const useCompetitionsSubmissionsCreate = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof competitionsSubmissionsCreate>>, TError,{licenseId: string;data: CSVUpload}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof competitionsSubmissionsCreate>>,
        TError,
        {licenseId: string;data: CSVUpload},
        TContext
      > => {

      const mutationOptions = getCompetitionsSubmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * ユーザチェック用のView
 */
export const emailCreate = (
    userCheckRequest: UserCheckRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('email', userCheckRequest.email)

      return orvalAxiosAdapter<PostUserCheckSuccess>(
      {url: `/api/v1/email/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getEmailCreateMutationOptions = <TError = InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailCreate>>, TError,{data: UserCheckRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof emailCreate>>, TError,{data: UserCheckRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailCreate>>, {data: UserCheckRequest}> = (props) => {
          const {data} = props ?? {};

          return  emailCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailCreateMutationResult = NonNullable<Awaited<ReturnType<typeof emailCreate>>>
    export type EmailCreateMutationBody = UserCheckRequest
    export type EmailCreateMutationError = InternalServerError

    export const useEmailCreate = <TError = InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailCreate>>, TError,{data: UserCheckRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof emailCreate>>,
        TError,
        {data: UserCheckRequest},
        TContext
      > => {

      const mutationOptions = getEmailCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * ユーザーが所有している資格を操作するためのView

GET: 資格を取得する
 */
export const grantedLicenseRetrieve = (
    licenseId: string,
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<CompetitionDetail>(
      {url: `/api/v1/granted_license/${licenseId}/${userId}`, method: 'GET', signal
    },
      );
    }
  

export const getGrantedLicenseRetrieveQueryKey = (licenseId: string,
    userId: string,) => {
    return [`/api/v1/granted_license/${licenseId}/${userId}`] as const;
    }

    
export const getGrantedLicenseRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError = Unauthorized | NotFound>(licenseId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGrantedLicenseRetrieveQueryKey(licenseId,userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof grantedLicenseRetrieve>>> = ({ signal }) => grantedLicenseRetrieve(licenseId,userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GrantedLicenseRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof grantedLicenseRetrieve>>>
export type GrantedLicenseRetrieveQueryError = Unauthorized | NotFound


export function useGrantedLicenseRetrieve<TData = Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof grantedLicenseRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGrantedLicenseRetrieve<TData = Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof grantedLicenseRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGrantedLicenseRetrieve<TData = Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGrantedLicenseRetrieve<TData = Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError = Unauthorized | NotFound>(
 licenseId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof grantedLicenseRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGrantedLicenseRetrieveQueryOptions(licenseId,userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ヘルスチェック用のView
 */
export const healthRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<GetHealthCheckSuccess>(
      {url: `/api/v1/health/`, method: 'GET', signal
    },
      );
    }
  

export const getHealthRetrieveQueryKey = () => {
    return [`/api/v1/health/`] as const;
    }

    
export const getHealthRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof healthRetrieve>>, TError = InternalServerError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthRetrieve>>> = ({ signal }) => healthRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof healthRetrieve>>>
export type HealthRetrieveQueryError = InternalServerError


export function useHealthRetrieve<TData = Awaited<ReturnType<typeof healthRetrieve>>, TError = InternalServerError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useHealthRetrieve<TData = Awaited<ReturnType<typeof healthRetrieve>>, TError = InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useHealthRetrieve<TData = Awaited<ReturnType<typeof healthRetrieve>>, TError = InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useHealthRetrieve<TData = Awaited<ReturnType<typeof healthRetrieve>>, TError = InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ヘルスチェック用のView
 */
export const healthCreate = (
    healthRequest: HealthRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('data', healthRequest.data)

      return orvalAxiosAdapter<PostHealthCheckSuccess>(
      {url: `/api/v1/health/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getHealthCreateMutationOptions = <TError = InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof healthCreate>>, TError,{data: HealthRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof healthCreate>>, TError,{data: HealthRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof healthCreate>>, {data: HealthRequest}> = (props) => {
          const {data} = props ?? {};

          return  healthCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HealthCreateMutationResult = NonNullable<Awaited<ReturnType<typeof healthCreate>>>
    export type HealthCreateMutationBody = HealthRequest
    export type HealthCreateMutationError = InternalServerError

    export const useHealthCreate = <TError = InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof healthCreate>>, TError,{data: HealthRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof healthCreate>>,
        TError,
        {data: HealthRequest},
        TContext
      > => {

      const mutationOptions = getHealthCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 組織を取得、更新、削除するView

GET: 組織の詳細情報を取得する

PATCH: 組織の情報を更新する

DELETE:（未実装） 組織を削除する（論理削除）
 */
export const organizationsRetrieve = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<OrganizationDetail>(
      {url: `/api/v1/organizations/${organizationId}/`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationsRetrieveQueryKey = (organizationId: string,) => {
    return [`/api/v1/organizations/${organizationId}/`] as const;
    }

    
export const getOrganizationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof organizationsRetrieve>>, TError = BadRequest | Unauthorized>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationsRetrieveQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationsRetrieve>>> = ({ signal }) => organizationsRetrieve(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof organizationsRetrieve>>>
export type OrganizationsRetrieveQueryError = BadRequest | Unauthorized


export function useOrganizationsRetrieve<TData = Awaited<ReturnType<typeof organizationsRetrieve>>, TError = BadRequest | Unauthorized>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useOrganizationsRetrieve<TData = Awaited<ReturnType<typeof organizationsRetrieve>>, TError = BadRequest | Unauthorized>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useOrganizationsRetrieve<TData = Awaited<ReturnType<typeof organizationsRetrieve>>, TError = BadRequest | Unauthorized>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useOrganizationsRetrieve<TData = Awaited<ReturnType<typeof organizationsRetrieve>>, TError = BadRequest | Unauthorized>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationsRetrieveQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 組織を取得、更新、削除するView

GET: 組織の詳細情報を取得する

PATCH: 組織の情報を更新する

DELETE:（未実装） 組織を削除する（論理削除）
 */
export const organizationsPartialUpdate = (
    organizationId: string,
    patchedOrganizationRequest: PatchedOrganizationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedOrganizationRequest.name !== undefined) {
 formUrlEncoded.append('name', patchedOrganizationRequest.name)
 }

      return orvalAxiosAdapter<Organization>(
      {url: `/api/v1/organizations/${organizationId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getOrganizationsPartialUpdateMutationOptions = <TError = Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsPartialUpdate>>, TError,{organizationId: string;data: PatchedOrganizationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationsPartialUpdate>>, TError,{organizationId: string;data: PatchedOrganizationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsPartialUpdate>>, {organizationId: string;data: PatchedOrganizationRequest}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationsPartialUpdate(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsPartialUpdate>>>
    export type OrganizationsPartialUpdateMutationBody = PatchedOrganizationRequest
    export type OrganizationsPartialUpdateMutationError = Unauthorized | Forbidden

    export const useOrganizationsPartialUpdate = <TError = Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsPartialUpdate>>, TError,{organizationId: string;data: PatchedOrganizationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof organizationsPartialUpdate>>,
        TError,
        {organizationId: string;data: PatchedOrganizationRequest},
        TContext
      > => {

      const mutationOptions = getOrganizationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 組織を取得、更新、削除するView

GET: 組織の詳細情報を取得する

PATCH: 組織の情報を更新する

DELETE:（未実装） 組織を削除する（論理削除）
 */
export const organizationsDestroy = (
    organizationId: string,
 ) => {
      
      
      return orvalAxiosAdapter<void>(
      {url: `/api/v1/organizations/${organizationId}/`, method: 'DELETE'
    },
      );
    }
  


export const getOrganizationsDestroyMutationOptions = <TError = Unauthorized | Forbidden | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsDestroy>>, TError,{organizationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationsDestroy>>, TError,{organizationId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsDestroy>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  organizationsDestroy(organizationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsDestroy>>>
    
    export type OrganizationsDestroyMutationError = Unauthorized | Forbidden | NotFound

    export const useOrganizationsDestroy = <TError = Unauthorized | Forbidden | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsDestroy>>, TError,{organizationId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof organizationsDestroy>>,
        TError,
        {organizationId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 組織に所属するユーザーを操作するためのView

POST: 組織にユーザーを追加する
 */
export const organizationsUsersCreate = (
    organizationId: string,
    organizationRequest: OrganizationRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('name', organizationRequest.name)

      return orvalAxiosAdapter<OrganizationUser>(
      {url: `/api/v1/organizations/${organizationId}/users/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getOrganizationsUsersCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersCreate>>, TError,{organizationId: string;data: OrganizationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersCreate>>, TError,{organizationId: string;data: OrganizationRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsUsersCreate>>, {organizationId: string;data: OrganizationRequest}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationsUsersCreate(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsUsersCreate>>>
    export type OrganizationsUsersCreateMutationBody = OrganizationRequest
    export type OrganizationsUsersCreateMutationError = BadRequest | Unauthorized | Forbidden | Conflict

    export const useOrganizationsUsersCreate = <TError = BadRequest | Unauthorized | Forbidden | Conflict,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersCreate>>, TError,{organizationId: string;data: OrganizationRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof organizationsUsersCreate>>,
        TError,
        {organizationId: string;data: OrganizationRequest},
        TContext
      > => {

      const mutationOptions = getOrganizationsUsersCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 組織に所属するユーザーを操作するためのView

PATCH: 組織に所属するユーザーの情報を更新する（ロール変更等）
DELETE: 組織からユーザーを削除する (中間テーブルのレコードを削除)
 */
export const organizationsUsersPartialUpdate = (
    organizationId: string,
    userId: string,
    patchedOrganizationUserPatchRequest: PatchedOrganizationUserPatchRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedOrganizationUserPatchRequest.role !== undefined) {
 formUrlEncoded.append('role', patchedOrganizationUserPatchRequest.role)
 }

      return orvalAxiosAdapter<OrganizationUser>(
      {url: `/api/v1/organizations/${organizationId}/users/${userId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getOrganizationsUsersPartialUpdateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersPartialUpdate>>, TError,{organizationId: string;userId: string;data: PatchedOrganizationUserPatchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersPartialUpdate>>, TError,{organizationId: string;userId: string;data: PatchedOrganizationUserPatchRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsUsersPartialUpdate>>, {organizationId: string;userId: string;data: PatchedOrganizationUserPatchRequest}> = (props) => {
          const {organizationId,userId,data} = props ?? {};

          return  organizationsUsersPartialUpdate(organizationId,userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsUsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsUsersPartialUpdate>>>
    export type OrganizationsUsersPartialUpdateMutationBody = PatchedOrganizationUserPatchRequest
    export type OrganizationsUsersPartialUpdateMutationError = BadRequest | Unauthorized | Forbidden | NotFound

    export const useOrganizationsUsersPartialUpdate = <TError = BadRequest | Unauthorized | Forbidden | NotFound,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersPartialUpdate>>, TError,{organizationId: string;userId: string;data: PatchedOrganizationUserPatchRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof organizationsUsersPartialUpdate>>,
        TError,
        {organizationId: string;userId: string;data: PatchedOrganizationUserPatchRequest},
        TContext
      > => {

      const mutationOptions = getOrganizationsUsersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 組織に所属するユーザーを操作するためのView

PATCH: 組織に所属するユーザーの情報を更新する（ロール変更等）
DELETE: 組織からユーザーを削除する (中間テーブルのレコードを削除)
 */
export const organizationsUsersDestroy = (
    organizationId: string,
    userId: string,
 ) => {
      
      
      return orvalAxiosAdapter<void>(
      {url: `/api/v1/organizations/${organizationId}/users/${userId}/`, method: 'DELETE'
    },
      );
    }
  


export const getOrganizationsUsersDestroyMutationOptions = <TError = Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersDestroy>>, TError,{organizationId: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersDestroy>>, TError,{organizationId: string;userId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsUsersDestroy>>, {organizationId: string;userId: string}> = (props) => {
          const {organizationId,userId} = props ?? {};

          return  organizationsUsersDestroy(organizationId,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsUsersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsUsersDestroy>>>
    
    export type OrganizationsUsersDestroyMutationError = Unauthorized

    export const useOrganizationsUsersDestroy = <TError = Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsUsersDestroy>>, TError,{organizationId: string;userId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof organizationsUsersDestroy>>,
        TError,
        {organizationId: string;userId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationsUsersDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * ユーザがサブミッションの添付ファイルを取得するためのViewクラス

GET: ダウンロードファイルを取得
 */
export const submissionAttachmentsRetrieve = (
    submissionId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<Blob>(
      {url: `/api/v1/submission_attachments/${submissionId}/`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getSubmissionAttachmentsRetrieveQueryKey = (submissionId: string,) => {
    return [`/api/v1/submission_attachments/${submissionId}/`] as const;
    }

    
export const getSubmissionAttachmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError = Unauthorized | NotFound>(submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmissionAttachmentsRetrieveQueryKey(submissionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>> = ({ signal }) => submissionAttachmentsRetrieve(submissionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(submissionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SubmissionAttachmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>>
export type SubmissionAttachmentsRetrieveQueryError = Unauthorized | NotFound


export function useSubmissionAttachmentsRetrieve<TData = Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSubmissionAttachmentsRetrieve<TData = Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSubmissionAttachmentsRetrieve<TData = Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useSubmissionAttachmentsRetrieve<TData = Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionAttachmentsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSubmissionAttachmentsRetrieveQueryOptions(submissionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ユーザが投稿した結果ファイル（results.json）を取得するためのViewクラス

GET: ダウンロードファイルを取得
 */
export const submissionResultRetrieve = (
    submissionId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<Blob>(
      {url: `/api/v1/submission_result/${submissionId}/`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getSubmissionResultRetrieveQueryKey = (submissionId: string,) => {
    return [`/api/v1/submission_result/${submissionId}/`] as const;
    }

    
export const getSubmissionResultRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof submissionResultRetrieve>>, TError = Unauthorized | NotFound>(submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionResultRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmissionResultRetrieveQueryKey(submissionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof submissionResultRetrieve>>> = ({ signal }) => submissionResultRetrieve(submissionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(submissionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submissionResultRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SubmissionResultRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof submissionResultRetrieve>>>
export type SubmissionResultRetrieveQueryError = Unauthorized | NotFound


export function useSubmissionResultRetrieve<TData = Awaited<ReturnType<typeof submissionResultRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionResultRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submissionResultRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSubmissionResultRetrieve<TData = Awaited<ReturnType<typeof submissionResultRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionResultRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submissionResultRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSubmissionResultRetrieve<TData = Awaited<ReturnType<typeof submissionResultRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionResultRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useSubmissionResultRetrieve<TData = Awaited<ReturnType<typeof submissionResultRetrieve>>, TError = Unauthorized | NotFound>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submissionResultRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSubmissionResultRetrieveQueryOptions(submissionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 指定したユーザーに対する操作を行うView

GET: 指定したユーザーの情報を取得する
 */
export const usersRetrieve = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<User>(
      {url: `/api/v1/users/${userId}/`, method: 'GET', signal
    },
      );
    }
  

export const getUsersRetrieveQueryKey = (userId: string,) => {
    return [`/api/v1/users/${userId}/`] as const;
    }

    
export const getUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = Unauthorized>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRetrieveQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRetrieve>>> = ({ signal }) => usersRetrieve(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersRetrieve>>>
export type UsersRetrieveQueryError = Unauthorized


export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = Unauthorized>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = Unauthorized>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = Unauthorized>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = Unauthorized>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ユーザの画像を取得するためのViewクラス

GET: 画像を取得

POST: 画像を投稿
 */
export const usersImageRetrieve = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<Blob>(
      {url: `/api/v1/users/${userId}/image`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getUsersImageRetrieveQueryKey = (userId: string,) => {
    return [`/api/v1/users/${userId}/image`] as const;
    }

    
export const getUsersImageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersImageRetrieve>>, TError = Unauthorized | NotFound>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersImageRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersImageRetrieveQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersImageRetrieve>>> = ({ signal }) => usersImageRetrieve(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersImageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersImageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersImageRetrieve>>>
export type UsersImageRetrieveQueryError = Unauthorized | NotFound


export function useUsersImageRetrieve<TData = Awaited<ReturnType<typeof usersImageRetrieve>>, TError = Unauthorized | NotFound>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersImageRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersImageRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useUsersImageRetrieve<TData = Awaited<ReturnType<typeof usersImageRetrieve>>, TError = Unauthorized | NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersImageRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersImageRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useUsersImageRetrieve<TData = Awaited<ReturnType<typeof usersImageRetrieve>>, TError = Unauthorized | NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersImageRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useUsersImageRetrieve<TData = Awaited<ReturnType<typeof usersImageRetrieve>>, TError = Unauthorized | NotFound>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersImageRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersImageRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ユーザの画像を取得するためのViewクラス

GET: 画像を取得

POST: 画像を投稿
 */
export const usersImageCreate = (
    userId: string,
    userImageUpload: UserImageUpload,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('file', userImageUpload.file)

      return orvalAxiosAdapter<UploadImage>(
      {url: `/api/v1/users/${userId}/image`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getUsersImageCreateMutationOptions = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersImageCreate>>, TError,{userId: string;data: UserImageUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersImageCreate>>, TError,{userId: string;data: UserImageUpload}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersImageCreate>>, {userId: string;data: UserImageUpload}> = (props) => {
          const {userId,data} = props ?? {};

          return  usersImageCreate(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersImageCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersImageCreate>>>
    export type UsersImageCreateMutationBody = UserImageUpload
    export type UsersImageCreateMutationError = BadRequest | Unauthorized | Forbidden

    export const useUsersImageCreate = <TError = BadRequest | Unauthorized | Forbidden,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersImageCreate>>, TError,{userId: string;data: UserImageUpload}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersImageCreate>>,
        TError,
        {userId: string;data: UserImageUpload},
        TContext
      > => {

      const mutationOptions = getUsersImageCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * リクエストしたユーザーに対する操作を行うView

GET: リクエストしたユーザーの情報を取得する

PATCH: リクエストしたユーザーの情報を更新する
 */
export const usersMeRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return orvalAxiosAdapter<User>(
      {url: `/api/v1/users/me/`, method: 'GET', signal
    },
      );
    }
  

export const getUsersMeRetrieveQueryKey = () => {
    return [`/api/v1/users/me/`] as const;
    }

    
export const getUsersMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = Unauthorized>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersMeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersMeRetrieve>>> = ({ signal }) => usersMeRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersMeRetrieve>>>
export type UsersMeRetrieveQueryError = Unauthorized


export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = Unauthorized>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersMeRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = Unauthorized>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersMeRetrieve>>,
          TError,
          TData
        > , 'initialData'
      >, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = Unauthorized>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = Unauthorized>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * リクエストしたユーザーに対する操作を行うView

GET: リクエストしたユーザーの情報を取得する

PATCH: リクエストしたユーザーの情報を更新する
 */
export const usersMePartialUpdate = (
    patchedUserPatchRequest: PatchedUserPatchRequest,
 ) => {
      
      const formUrlEncoded = new URLSearchParams();
if(patchedUserPatchRequest.displayName !== undefined) {
 formUrlEncoded.append('displayName', patchedUserPatchRequest.displayName)
 }
if(patchedUserPatchRequest.hasPassword !== undefined) {
 formUrlEncoded.append('hasPassword', patchedUserPatchRequest.hasPassword.toString())
 }

      return orvalAxiosAdapter<User>(
      {url: `/api/v1/users/me/`, method: 'PATCH',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded
    },
      );
    }
  


export const getUsersMePartialUpdateMutationOptions = <TError = Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersMePartialUpdate>>, TError,{data: PatchedUserPatchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersMePartialUpdate>>, TError,{data: PatchedUserPatchRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersMePartialUpdate>>, {data: PatchedUserPatchRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersMePartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersMePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersMePartialUpdate>>>
    export type UsersMePartialUpdateMutationBody = PatchedUserPatchRequest
    export type UsersMePartialUpdateMutationError = Unauthorized

    export const useUsersMePartialUpdate = <TError = Unauthorized,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersMePartialUpdate>>, TError,{data: PatchedUserPatchRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersMePartialUpdate>>,
        TError,
        {data: PatchedUserPatchRequest},
        TContext
      > => {

      const mutationOptions = getUsersMePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
